// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const AccountingConnection = __t.object("AccountingConnection", {
  id: __t.string(),
  platform: __t.string(),
});
export type AccountingConnection = __Infer<typeof AccountingConnection>;

export const AccountingItemDataSync = __t.object("AccountingItemDataSync", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  accountingTychoId: __t.u64(),
  underwritableEntityV1: __t.u64(),
});
export type AccountingItemDataSync = __Infer<typeof AccountingItemDataSync>;

export const AccountingItemForUserRow = __t.object("AccountingItemForUserRow", {
  tychoId: __t.uuid(),
  platform: __t.string(),
  createdAt: __t.timestamp(),
});
export type AccountingItemForUserRow = __Infer<typeof AccountingItemForUserRow>;

export const AccountingItemsToUnderwritableEntitiesV1 = __t.object("AccountingItemsToUnderwritableEntitiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  accountingItemV1: __t.u64(),
  underwritableEntityV1: __t.u64(),
});
export type AccountingItemsToUnderwritableEntitiesV1 = __Infer<typeof AccountingItemsToUnderwritableEntitiesV1>;

export const AccountingItemsToUnderwritableEntitiesV2 = __t.object("AccountingItemsToUnderwritableEntitiesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  accountingItem: __t.uuid(),
  underwritableEntity: __t.uuid(),
});
export type AccountingItemsToUnderwritableEntitiesV2 = __Infer<typeof AccountingItemsToUnderwritableEntitiesV2>;

export const AccountingItemsV1 = __t.object("AccountingItemsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  tychoId: __t.u64(),
  rutterConnectionId: __t.string(),
  rutterAccessToken: __t.string(),
  platform: __t.string(),
  get jobStatus() {
    return AthenaAsyncStatusFieldsJobStatus;
  },
  error: __t.option(__t.string()),
});
export type AccountingItemsV1 = __Infer<typeof AccountingItemsV1>;

export const AccountingItemsV2 = __t.object("AccountingItemsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  tychoId: __t.uuid(),
  rutterConnectionId: __t.string(),
  rutterAccessToken: __t.string(),
  platform: __t.string(),
  get jobStatus() {
    return AthenaAsyncStatusFieldsJobStatus;
  },
  error: __t.option(__t.string()),
});
export type AccountingItemsV2 = __Infer<typeof AccountingItemsV2>;

export const AccountingScheduledItemsV2 = __t.object("AccountingScheduledItemsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  accountingTychoId: __t.uuid(),
  underwritableEntity: __t.uuid(),
});
export type AccountingScheduledItemsV2 = __Infer<typeof AccountingScheduledItemsV2>;

// The tagged union or sum type for the algebraic type `AdditionalInfoType`.
export const AdditionalInfoType = __t.enum("AdditionalInfoType", {
  Quickbooks: __t.unit(),
});
export type AdditionalInfoType = __Infer<typeof AdditionalInfoType>;

export const AdminAccountingConnection = __t.object("AdminAccountingConnection", {
  accountingItemTychoId: __t.uuid(),
  underwritableEntity: __t.uuid(),
  platform: __t.string(),
  rutterConnectionId: __t.string(),
  get jobStatus() {
    return AthenaAsyncStatusFieldsJobStatus;
  },
});
export type AdminAccountingConnection = __Infer<typeof AdminAccountingConnection>;

export const AdminAccountingConnections = __t.object("AdminAccountingConnections", {});
export type AdminAccountingConnections = __Infer<typeof AdminAccountingConnections>;

export const AdminBrandRow = __t.object("AdminBrandRow", {
  brandId: __t.uuid(),
  friendlyName: __t.string(),
  get businessStory() {
    return BusinessStory;
  },
  primaryUserEmail: __t.option(__t.string()),
  primaryUwEntityId: __t.option(__t.uuid()),
  targetedPropertyCount: __t.u32(),
  compsComputedCount: __t.u32(),
  compsSelectedCount: __t.u32(),
  accountingCount: __t.u32(),
  plaidCount: __t.u32(),
  posCount: __t.u32(),
  leaseDocCount: __t.u32(),
  taxReturnCount: __t.u32(),
  uwQuestionsAskedCount: __t.u32(),
  uwQuestionsAnsweredCount: __t.u32(),
  hasSharedBusinessCard: __t.bool(),
});
export type AdminBrandRow = __Infer<typeof AdminBrandRow>;

export const AdminBrandSnapshotResult = __t.object("AdminBrandSnapshotResult", {
  get superView() {
    return __t.array(SmbSuperViewElement);
  },
  get cardEngineInputs() {
    return __t.array(CardEngineInput);
  },
  get underwritableEntities() {
    return __t.array(UnderwritableEntitiesV4);
  },
  get brands() {
    return __t.array(BrandsV4);
  },
  get shareBusinessCardContexts() {
    return __t.array(ShareBusinessCardContextRow);
  },
  get targetableProperties() {
    return __t.array(TargetablePropertyForUserRow);
  },
  get operatingProperties() {
    return __t.array(OperatingPropertyForUserRow);
  },
  get operatingPropertiesJobStatus() {
    return __t.array(OperatingPropertiesJobStatusForUserRow);
  },
});
export type AdminBrandSnapshotResult = __Infer<typeof AdminBrandSnapshotResult>;

export const AdminClaimNominationResultRow = __t.object("AdminClaimNominationResultRow", {
  claimId: __t.string(),
  brand: __t.uuid(),
  nominatedBusiness: __t.string(),
  claimerClerkUserId: __t.string(),
});
export type AdminClaimNominationResultRow = __Infer<typeof AdminClaimNominationResultRow>;

export const AdminClaimableBrandRow = __t.object("AdminClaimableBrandRow", {
  id: __t.uuid(),
  friendlyName: __t.string(),
  googlePlaceId: __t.option(__t.string()),
  get canonicalAddress() {
    return __t.option(CanonicalAddress);
  },
  primaryUserEmail: __t.option(__t.string()),
  claimedNominationId: __t.option(__t.string()),
  claimedNominationName: __t.option(__t.string()),
  hasLiveClaim: __t.bool(),
});
export type AdminClaimableBrandRow = __Infer<typeof AdminClaimableBrandRow>;

export const AdminClaimableNominationRow = __t.object("AdminClaimableNominationRow", {
  id: __t.string(),
  name: __t.option(__t.string()),
  googlePlaceId: __t.string(),
  businessType: __t.option(__t.string()),
  get canonicalAddress() {
    return __t.option(CanonicalAddress);
  },
  totalInterested: __t.u32(),
  totalInterestDollars: __t.u64(),
  claimedByBrandFriendlyName: __t.option(__t.string()),
  isClaimed: __t.bool(),
});
export type AdminClaimableNominationRow = __Infer<typeof AdminClaimableNominationRow>;

export const AdminClaimableNominationsResult = __t.object("AdminClaimableNominationsResult", {
  get nominations() {
    return __t.array(AdminClaimableNominationRow);
  },
  get brands() {
    return __t.array(AdminClaimableBrandRow);
  },
});
export type AdminClaimableNominationsResult = __Infer<typeof AdminClaimableNominationsResult>;

export const AdminInvestorTransactAccountRow = __t.object("AdminInvestorTransactAccountRow", {
  clerkUserId: __t.string(),
  partyId: __t.string(),
  accountId: __t.string(),
  linkId: __t.string(),
  createdAt: __t.timestamp(),
  raw: __t.string(),
});
export type AdminInvestorTransactAccountRow = __Infer<typeof AdminInvestorTransactAccountRow>;

export const AdminInvestorTransactAccounts = __t.object("AdminInvestorTransactAccounts", {});
export type AdminInvestorTransactAccounts = __Infer<typeof AdminInvestorTransactAccounts>;

export const AdminListBrandsResult = __t.object("AdminListBrandsResult", {
  get brands() {
    return __t.array(AdminBrandRow);
  },
});
export type AdminListBrandsResult = __Infer<typeof AdminListBrandsResult>;

export const AdminListInvitedBrandDraftsResult = __t.object("AdminListInvitedBrandDraftsResult", {
  get drafts() {
    return __t.array(InvitedBrandDraftRow);
  },
});
export type AdminListInvitedBrandDraftsResult = __Infer<typeof AdminListInvitedBrandDraftsResult>;

export const AdminOfferingRow = __t.object("AdminOfferingRow", {
  id: __t.uuid(),
  ttwPage: __t.uuid(),
  transactOfferingId: __t.option(__t.string()),
  name: __t.string(),
  status: __t.string(),
  targetAmountCents: __t.i64(),
  maxAmountCents: __t.i64(),
  minCheckSizeCents: __t.i64(),
  startDateMs: __t.i64(),
  endDateMs: __t.i64(),
  maxPerInvestorCents: __t.option(__t.i64()),
  transactStatus: __t.option(__t.string()),
});
export type AdminOfferingRow = __Infer<typeof AdminOfferingRow>;

export const AdminOfferings = __t.object("AdminOfferings", {});
export type AdminOfferings = __Infer<typeof AdminOfferings>;

export const AdminRestartAccountingResult = __t.object("AdminRestartAccountingResult", {
  restartedCount: __t.u32(),
});
export type AdminRestartAccountingResult = __Infer<typeof AdminRestartAccountingResult>;

export const AdminRestartPlaidResult = __t.object("AdminRestartPlaidResult", {
  restartedCount: __t.u32(),
});
export type AdminRestartPlaidResult = __Infer<typeof AdminRestartPlaidResult>;

export const AdminRestartPosResult = __t.object("AdminRestartPosResult", {
  restartedCount: __t.u32(),
});
export type AdminRestartPosResult = __Infer<typeof AdminRestartPosResult>;

export const AdminRestartTaxReturnResult = __t.object("AdminRestartTaxReturnResult", {
  restartedCount: __t.u32(),
});
export type AdminRestartTaxReturnResult = __Infer<typeof AdminRestartTaxReturnResult>;

export const AdminRetriggerLeaseDocResult = __t.object("AdminRetriggerLeaseDocResult", {
  retriggeredCount: __t.u32(),
});
export type AdminRetriggerLeaseDocResult = __Infer<typeof AdminRetriggerLeaseDocResult>;

export const AdminShareableBusinessCardRow = __t.object("AdminShareableBusinessCardRow", {
  id: __t.uuid(),
  underwritableEntity: __t.uuid(),
  friendlyName: __t.option(__t.string()),
  brandFriendlyName: __t.option(__t.string()),
  accessCode: __t.option(__t.string()),
  isActive: __t.bool(),
  browsable: __t.bool(),
});
export type AdminShareableBusinessCardRow = __Infer<typeof AdminShareableBusinessCardRow>;

export const AdminShareableBusinessCards = __t.object("AdminShareableBusinessCards", {});
export type AdminShareableBusinessCards = __Infer<typeof AdminShareableBusinessCards>;

export const AdminTargetableProperties = __t.object("AdminTargetableProperties", {});
export type AdminTargetableProperties = __Infer<typeof AdminTargetableProperties>;

export const AdminTargetablePropertyRow = __t.object("AdminTargetablePropertyRow", {
  id: __t.uuid(),
  get canonicalAddress() {
    return CanonicalAddress;
  },
  googlePlaceId: __t.option(__t.string()),
  googlePlacePhotoName: __t.option(__t.string()),
  imageUrl: __t.option(__t.string()),
  get source() {
    return TargetablePropertySourceV1;
  },
  externalId: __t.option(__t.string()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
});
export type AdminTargetablePropertyRow = __Infer<typeof AdminTargetablePropertyRow>;

export const AdminTransactAccountRow = __t.object("AdminTransactAccountRow", {
  accountId: __t.string(),
  accountName: __t.string(),
  type: __t.string(),
  kycStatus: __t.string(),
  amlStatus: __t.string(),
  accreditedStatus: __t.string(),
  raw: __t.string(),
});
export type AdminTransactAccountRow = __Infer<typeof AdminTransactAccountRow>;

export const AdminTransactAccounts = __t.object("AdminTransactAccounts", {});
export type AdminTransactAccounts = __Infer<typeof AdminTransactAccounts>;

export const AdminTransactFundMoveOpRow = __t.object("AdminTransactFundMoveOpRow", {
  id: __t.u64(),
  status: __t.string(),
  tradeId: __t.string(),
  accountId: __t.string(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  raw: __t.string(),
});
export type AdminTransactFundMoveOpRow = __Infer<typeof AdminTransactFundMoveOpRow>;

export const AdminTransactFundMoveOps = __t.object("AdminTransactFundMoveOps", {});
export type AdminTransactFundMoveOps = __Infer<typeof AdminTransactFundMoveOps>;

export const AdminTransactLinkOpRow = __t.object("AdminTransactLinkOpRow", {
  id: __t.u64(),
  status: __t.string(),
  accountId: __t.string(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  raw: __t.string(),
});
export type AdminTransactLinkOpRow = __Infer<typeof AdminTransactLinkOpRow>;

export const AdminTransactLinkOps = __t.object("AdminTransactLinkOps", {});
export type AdminTransactLinkOps = __Infer<typeof AdminTransactLinkOps>;

export const AdminTransactLinkRow = __t.object("AdminTransactLinkRow", {
  id: __t.string(),
  firstEntry: __t.string(),
  relatedEntry: __t.string(),
  relatedEntryType: __t.string(),
  linkType: __t.option(__t.string()),
  raw: __t.string(),
});
export type AdminTransactLinkRow = __Infer<typeof AdminTransactLinkRow>;

export const AdminTransactLinks = __t.object("AdminTransactLinks", {});
export type AdminTransactLinks = __Infer<typeof AdminTransactLinks>;

export const AdminTransactParties = __t.object("AdminTransactParties", {});
export type AdminTransactParties = __Infer<typeof AdminTransactParties>;

export const AdminTransactPartyRow = __t.object("AdminTransactPartyRow", {
  partyId: __t.string(),
  firstName: __t.string(),
  lastName: __t.string(),
  emailAddress: __t.string(),
  kycStatus: __t.option(__t.string()),
  amlStatus: __t.option(__t.string()),
  field1: __t.option(__t.string()),
  raw: __t.string(),
});
export type AdminTransactPartyRow = __Infer<typeof AdminTransactPartyRow>;

export const AdminTransactSyncJobRow = __t.object("AdminTransactSyncJobRow", {
  id: __t.u64(),
  entity: __t.string(),
  status: __t.string(),
  currentOffset: __t.i32(),
  pagesProcessed: __t.i32(),
  raw: __t.string(),
});
export type AdminTransactSyncJobRow = __Infer<typeof AdminTransactSyncJobRow>;

export const AdminTransactSyncJobs = __t.object("AdminTransactSyncJobs", {});
export type AdminTransactSyncJobs = __Infer<typeof AdminTransactSyncJobs>;

export const AdminTtwHighlight = __t.object("AdminTtwHighlight", {
  text: __t.string(),
  icon: __t.string(),
});
export type AdminTtwHighlight = __Infer<typeof AdminTtwHighlight>;

export const AdminTtwKeyStat = __t.object("AdminTtwKeyStat", {
  label: __t.string(),
  icon: __t.string(),
  value: __t.string(),
});
export type AdminTtwKeyStat = __Infer<typeof AdminTtwKeyStat>;

export const AdminTtwPageRow = __t.object("AdminTtwPageRow", {
  id: __t.uuid(),
  shareableBusinessCard: __t.uuid(),
  cardIsLive: __t.bool(),
  cardIsAccessProtected: __t.bool(),
  brandFriendlyName: __t.option(__t.string()),
  ownerEmail: __t.option(__t.string()),
  get targetPropertyAddress() {
    return __t.option(CanonicalAddress);
  },
  featureImage: __t.string(),
  get pitchVideoKind() {
    return TtwPitchVideoKindV1;
  },
  pitchVideoValue: __t.option(__t.string()),
  get pitchVideoProvider() {
    return __t.option(TtwVideoProviderV1);
  },
  businessName: __t.string(),
  category: __t.string(),
  targetProperty: __t.option(__t.uuid()),
  showNominator: __t.bool(),
  showTotalReserved: __t.bool(),
  showAppreciationShare: __t.bool(),
  get highlights() {
    return __t.array(AdminTtwHighlight);
  },
  stewardImage: __t.option(__t.string()),
  stewardQuote: __t.option(__t.string()),
  stewardAttribution: __t.option(__t.string()),
  stewardAbout: __t.option(__t.string()),
  get keyStats() {
    return __t.array(AdminTtwKeyStat);
  },
  realEstateAbout: __t.option(__t.string()),
  targetArea: __t.option(__t.string()),
  gallery: __t.array(__t.string()),
  propertyType: __t.option(__t.string()),
  stories: __t.option(__t.string()),
  yearBuilt: __t.option(__t.string()),
  propertySqft: __t.option(__t.i32()),
  showEstimatedValueChart: __t.bool(),
  catalogPropertySqft: __t.option(__t.f64()),
  sharePriceCents: __t.i64(),
  totalShares: __t.i64(),
  targetReturnBps: __t.i32(),
  targetReturnBpsMax: __t.i32(),
  targetRaiseCents: __t.i64(),
  get stage() {
    return TtwPageStageV1;
  },
  appreciationShareBps: __t.i32(),
});
export type AdminTtwPageRow = __Infer<typeof AdminTtwPageRow>;

export const AdminTtwPages = __t.object("AdminTtwPages", {});
export type AdminTtwPages = __Infer<typeof AdminTtwPages>;

export const AdminUnderwritingQuestionsView = __t.object("AdminUnderwritingQuestionsView", {});
export type AdminUnderwritingQuestionsView = __Infer<typeof AdminUnderwritingQuestionsView>;

export const AdminUpdatedShareableBusinessCardRow = __t.object("AdminUpdatedShareableBusinessCardRow", {
  id: __t.uuid(),
});
export type AdminUpdatedShareableBusinessCardRow = __Infer<typeof AdminUpdatedShareableBusinessCardRow>;

export const AdminUserInfo = __t.object("AdminUserInfo", {});
export type AdminUserInfo = __Infer<typeof AdminUserInfo>;

export const AdminUserInfoMutationResult = __t.object("AdminUserInfoMutationResult", {
  clerkUserId: __t.string(),
});
export type AdminUserInfoMutationResult = __Infer<typeof AdminUserInfoMutationResult>;

export const AdminUserInfoRow = __t.object("AdminUserInfoRow", {
  clerkUserId: __t.string(),
  firstName: __t.string(),
  lastName: __t.string(),
  phone: __t.string(),
  dob: __t.string(),
  citizenship: __t.string(),
  residency: __t.string(),
  get address() {
    return CanonicalAddress;
  },
});
export type AdminUserInfoRow = __Infer<typeof AdminUserInfoRow>;

export const AllAccountingItemsForUser = __t.object("AllAccountingItemsForUser", {});
export type AllAccountingItemsForUser = __Infer<typeof AllAccountingItemsForUser>;

export const AllBrandsForUser = __t.object("AllBrandsForUser", {});
export type AllBrandsForUser = __Infer<typeof AllBrandsForUser>;

export const AllLeaseDocsForUser = __t.object("AllLeaseDocsForUser", {});
export type AllLeaseDocsForUser = __Infer<typeof AllLeaseDocsForUser>;

export const AllMergeItemsForUser = __t.object("AllMergeItemsForUser", {});
export type AllMergeItemsForUser = __Infer<typeof AllMergeItemsForUser>;

export const AllNominationsRow = __t.object("AllNominationsRow", {
  id: __t.string(),
  googlePlaceId: __t.string(),
  name: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  totalInterested: __t.u32(),
  get canonicalAddress() {
    return __t.option(CanonicalAddress);
  },
});
export type AllNominationsRow = __Infer<typeof AllNominationsRow>;

export const AllOperatingPropertiesForUser = __t.object("AllOperatingPropertiesForUser", {});
export type AllOperatingPropertiesForUser = __Infer<typeof AllOperatingPropertiesForUser>;

export const AllPlaidItemsForUser = __t.object("AllPlaidItemsForUser", {});
export type AllPlaidItemsForUser = __Infer<typeof AllPlaidItemsForUser>;

export const AllPosItemsForUser = __t.object("AllPosItemsForUser", {});
export type AllPosItemsForUser = __Infer<typeof AllPosItemsForUser>;

export const AllTargetablePropertiesForUser = __t.object("AllTargetablePropertiesForUser", {});
export type AllTargetablePropertiesForUser = __Infer<typeof AllTargetablePropertiesForUser>;

export const AllTaxReturnsForUser = __t.object("AllTaxReturnsForUser", {});
export type AllTaxReturnsForUser = __Infer<typeof AllTaxReturnsForUser>;

export const AllUnderwritableEntitiesForUser = __t.object("AllUnderwritableEntitiesForUser", {});
export type AllUnderwritableEntitiesForUser = __Infer<typeof AllUnderwritableEntitiesForUser>;

export const AppliedMigrationRow = __t.object("AppliedMigrationRow", {
  name: __t.string(),
  appliedAt: __t.timestamp(),
});
export type AppliedMigrationRow = __Infer<typeof AppliedMigrationRow>;

export const AppliedMigrations = __t.object("AppliedMigrations", {});
export type AppliedMigrations = __Infer<typeof AppliedMigrations>;

export const AppraisalsV1 = __t.object("AppraisalsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  underwritableEntityV1: __t.u64(),
  targetablePropertyV1: __t.u64(),
  appraisalValue: __t.option(__t.f64()),
});
export type AppraisalsV1 = __Infer<typeof AppraisalsV1>;

export const AppraisalsV2 = __t.object("AppraisalsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  underwritableEntity: __t.uuid(),
  targetableProperty: __t.uuid(),
  appraisalValue: __t.option(__t.f64()),
});
export type AppraisalsV2 = __Infer<typeof AppraisalsV2>;

// The tagged union or sum type for the algebraic type `AthenaAsyncStatusFieldsJobStatus`.
export const AthenaAsyncStatusFieldsJobStatus = __t.enum("AthenaAsyncStatusFieldsJobStatus", {
  Complete: __t.unit(),
  InProgress: __t.unit(),
  Retrying: __t.unit(),
  Failed: __t.unit(),
  Unknown: __t.unit(),
});
export type AthenaAsyncStatusFieldsJobStatus = __Infer<typeof AthenaAsyncStatusFieldsJobStatus>;

export const AthenaBankingConnectionResponse = __t.object("AthenaBankingConnectionResponse", {
  dataIngested: __t.bool(),
  get accounts() {
    return __t.array(BankAccountValidator);
  },
  get connection() {
    return BankConnectionValidator;
  },
});
export type AthenaBankingConnectionResponse = __Infer<typeof AthenaBankingConnectionResponse>;

export const AvatarUploadUrl = __t.object("AvatarUploadUrl", {
  uploadUrl: __t.string(),
  objectPath: __t.string(),
  contentType: __t.string(),
  contentLengthRange: __t.string(),
});
export type AvatarUploadUrl = __Infer<typeof AvatarUploadUrl>;

export const BackfilledShareableBusinessCardsRow = __t.object("BackfilledShareableBusinessCardsRow", {
  updated: __t.u32(),
});
export type BackfilledShareableBusinessCardsRow = __Infer<typeof BackfilledShareableBusinessCardsRow>;

export const BankAccountValidator = __t.object("BankAccountValidator", {
  accountId: __t.string(),
  balanceAvailable: __t.option(__t.f64()),
  balanceCurrent: __t.option(__t.f64()),
  holderCategory: __t.option(__t.string()),
  mask: __t.option(__t.string()),
  name: __t.string(),
  officialName: __t.option(__t.string()),
  subtype: __t.option(__t.string()),
  type: __t.string(),
});
export type BankAccountValidator = __Infer<typeof BankAccountValidator>;

export const BankConnectionValidator = __t.object("BankConnectionValidator", {
  itemId: __t.string(),
  institutionId: __t.string(),
  institutionName: __t.string(),
});
export type BankConnectionValidator = __Infer<typeof BankConnectionValidator>;

export const BankingConnection = __t.object("BankingConnection", {
  id: __t.string(),
  institutionName: __t.string(),
});
export type BankingConnection = __Infer<typeof BankingConnection>;

export const BeginInvitedBrandOnboardingResult = __t.object("BeginInvitedBrandOnboardingResult", {
  get status() {
    return BeginInvitedBrandOnboardingStatus;
  },
  draftId: __t.option(__t.uuid()),
  get invitedStep() {
    return __t.option(InvitedOnboardingStep);
  },
});
export type BeginInvitedBrandOnboardingResult = __Infer<typeof BeginInvitedBrandOnboardingResult>;

// The tagged union or sum type for the algebraic type `BeginInvitedBrandOnboardingStatus`.
export const BeginInvitedBrandOnboardingStatus = __t.enum("BeginInvitedBrandOnboardingStatus", {
  Ok: __t.unit(),
  Conflict: __t.unit(),
});
export type BeginInvitedBrandOnboardingStatus = __Infer<typeof BeginInvitedBrandOnboardingStatus>;

export const BrandInviteEmailScheduleV1 = __t.object("BrandInviteEmailScheduleV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  invite: __t.uuid(),
  attempts: __t.u32(),
});
export type BrandInviteEmailScheduleV1 = __Infer<typeof BrandInviteEmailScheduleV1>;

// The tagged union or sum type for the algebraic type `BrandInviteStatus`.
export const BrandInviteStatus = __t.enum("BrandInviteStatus", {
  Pending: __t.unit(),
  Accepted: __t.unit(),
  Declined: __t.unit(),
  Revoked: __t.unit(),
});
export type BrandInviteStatus = __Infer<typeof BrandInviteStatus>;

export const BrandInvitesV1 = __t.object("BrandInvitesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  brand: __t.uuid(),
  email: __t.string(),
  invitedByClerkUserId: __t.string(),
  get role() {
    return BrandUserRolesEnum;
  },
  get status() {
    return BrandInviteStatus;
  },
  acceptedByClerkUserId: __t.option(__t.string()),
});
export type BrandInvitesV1 = __Infer<typeof BrandInvitesV1>;

export const BrandMemberRow = __t.object("BrandMemberRow", {
  brand: __t.uuid(),
  clerkUserId: __t.string(),
  email: __t.string(),
  displayName: __t.string(),
  isAdmin: __t.bool(),
  isSelf: __t.bool(),
});
export type BrandMemberRow = __Infer<typeof BrandMemberRow>;

export const BrandMembers = __t.object("BrandMembers", {});
export type BrandMembers = __Infer<typeof BrandMembers>;

export const BrandMembersRow = __t.object("BrandMembersRow", {
  get members() {
    return __t.array(BrandMemberRow);
  },
  get pendingInvites() {
    return __t.array(BrandPendingInviteRow);
  },
});
export type BrandMembersRow = __Infer<typeof BrandMembersRow>;

export const BrandPendingInviteRow = __t.object("BrandPendingInviteRow", {
  brand: __t.uuid(),
  inviteId: __t.uuid(),
  email: __t.string(),
});
export type BrandPendingInviteRow = __Infer<typeof BrandPendingInviteRow>;

// The tagged union or sum type for the algebraic type `BrandUserRolesEnum`.
export const BrandUserRolesEnum = __t.enum("BrandUserRolesEnum", {
  Admin: __t.unit(),
  Employee: __t.unit(),
});
export type BrandUserRolesEnum = __Infer<typeof BrandUserRolesEnum>;

export const BrandsToTargetablePropertiesV1 = __t.object("BrandsToTargetablePropertiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  brandV1: __t.u64(),
  targetablePropertyV1: __t.u64(),
});
export type BrandsToTargetablePropertiesV1 = __Infer<typeof BrandsToTargetablePropertiesV1>;

export const BrandsToTargetablePropertiesV2 = __t.object("BrandsToTargetablePropertiesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  brand: __t.uuid(),
  targetableProperty: __t.uuid(),
});
export type BrandsToTargetablePropertiesV2 = __Infer<typeof BrandsToTargetablePropertiesV2>;

export const BrandsToUsersV1 = __t.object("BrandsToUsersV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  brandV1: __t.u64(),
  clerkUserIdV1: __t.string(),
  get userRoles() {
    return __t.array(BrandUserRolesEnum);
  },
});
export type BrandsToUsersV1 = __Infer<typeof BrandsToUsersV1>;

export const BrandsToUsersV2 = __t.object("BrandsToUsersV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  brand: __t.uuid(),
  clerkUserId: __t.string(),
  get userRoles() {
    return __t.array(BrandUserRolesEnum);
  },
});
export type BrandsToUsersV2 = __Infer<typeof BrandsToUsersV2>;

export const BrandsV1 = __t.object("BrandsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  friendlyName: __t.string(),
  get demographics() {
    return __t.array(BusinessOwnerDemographics);
  },
  get managementStyles() {
    return __t.array(BusinessManagementStyle);
  },
  get philosophies() {
    return __t.array(BusinessPhilosophy);
  },
  googlePlaceId: __t.option(__t.string()),
  get businessAddress() {
    return CanonicalAddress;
  },
  businessCategory: __t.string(),
  businessType: __t.string(),
  websiteUrl: __t.option(__t.string()),
  businessTags: __t.array(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorSecondary: __t.option(__t.string()),
  colorTertiary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  nominationClaimV1: __t.option(__t.string()),
});
export type BrandsV1 = __Infer<typeof BrandsV1>;

export const BrandsV2 = __t.object("BrandsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  friendlyName: __t.string(),
  get demographics() {
    return __t.array(BusinessOwnerDemographics);
  },
  get managementStyles() {
    return __t.array(BusinessManagementStyle);
  },
  get philosophies() {
    return __t.array(BusinessPhilosophy);
  },
  googlePlaceId: __t.option(__t.string()),
  get businessAddress() {
    return CanonicalAddress;
  },
  businessCategory: __t.string(),
  businessType: __t.string(),
  websiteUrl: __t.option(__t.string()),
  businessTags: __t.array(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorSecondary: __t.option(__t.string()),
  colorTertiary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  nominationClaim: __t.option(__t.string()),
});
export type BrandsV2 = __Infer<typeof BrandsV2>;

export const BrandsV3 = __t.object("BrandsV3", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  friendlyName: __t.string(),
  get demographics() {
    return __t.array(BusinessOwnerDemographics);
  },
  get managementStyles() {
    return __t.array(BusinessManagementStyle);
  },
  get philosophies() {
    return __t.array(BusinessPhilosophy);
  },
  googlePlaceId: __t.option(__t.string()),
  get businessAddress() {
    return CanonicalAddress;
  },
  businessCategory: __t.string(),
  businessType: __t.string(),
  websiteUrl: __t.option(__t.string()),
  businessTags: __t.array(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorSecondary: __t.option(__t.string()),
  colorTertiary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  nominationClaim: __t.option(__t.string()),
  get opLocationsJobStatus() {
    return __t.option(OpLocationsJobStatusV1);
  },
  opLocationsJobStarted: __t.option(__t.bool()),
  opLocationsJobAttempts: __t.option(__t.u32()),
  opLocationsJobCreatedAt: __t.option(__t.timestamp()),
  opLocationsJobLastPolledAt: __t.option(__t.timestamp()),
  opLocationsJobCompletedAt: __t.option(__t.timestamp()),
  opLocationsJobErrorKind: __t.option(__t.string()),
  opLocationsJobErrorMessage: __t.option(__t.string()),
});
export type BrandsV3 = __Infer<typeof BrandsV3>;

export const BrandsV4 = __t.object("BrandsV4", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  friendlyName: __t.string(),
  get demographics() {
    return __t.array(BusinessOwnerDemographics);
  },
  get managementStyles() {
    return __t.array(BusinessManagementStyle);
  },
  get philosophies() {
    return __t.array(BusinessPhilosophy);
  },
  googlePlaceId: __t.option(__t.string()),
  get businessAddress() {
    return CanonicalAddress;
  },
  businessCategory: __t.string(),
  businessType: __t.string(),
  websiteUrl: __t.option(__t.string()),
  businessTags: __t.array(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorSecondary: __t.option(__t.string()),
  colorTertiary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  nominationClaim: __t.option(__t.string()),
  get opLocationsJobStatus() {
    return __t.option(OpLocationsJobStatusV1);
  },
  opLocationsJobStarted: __t.option(__t.bool()),
  opLocationsJobAttempts: __t.option(__t.u32()),
  opLocationsJobCreatedAt: __t.option(__t.timestamp()),
  opLocationsJobLastPolledAt: __t.option(__t.timestamp()),
  opLocationsJobCompletedAt: __t.option(__t.timestamp()),
  opLocationsJobErrorKind: __t.option(__t.string()),
  opLocationsJobErrorMessage: __t.option(__t.string()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  get businessStory() {
    return BusinessStory;
  },
});
export type BrandsV4 = __Infer<typeof BrandsV4>;

export const BrowseMissingCoordinateRow = __t.object("BrowseMissingCoordinateRow", {
  kind: __t.string(),
  id: __t.string(),
  name: __t.string(),
  get canonicalAddress() {
    return __t.option(CanonicalAddress);
  },
});
export type BrowseMissingCoordinateRow = __Infer<typeof BrowseMissingCoordinateRow>;

export const BrowseMissingCoordinatesResult = __t.object("BrowseMissingCoordinatesResult", {
  get rows() {
    return __t.array(BrowseMissingCoordinateRow);
  },
});
export type BrowseMissingCoordinatesResult = __Infer<typeof BrowseMissingCoordinatesResult>;

export const BusinessCardWithInterests = __t.object("BusinessCardWithInterests", {
  get businessCard() {
    return ShareableBusinessCardsV3;
  },
  get allPledges() {
    return __t.array(CardPledgeSummary);
  },
});
export type BusinessCardWithInterests = __Infer<typeof BusinessCardWithInterests>;

// The tagged union or sum type for the algebraic type `BusinessManagementStyle`.
export const BusinessManagementStyle = __t.enum("BusinessManagementStyle", {
  MomAndPop: __t.unit(),
  OwnerOperated: __t.unit(),
  FamilyBusiness: __t.unit(),
  GenerationalBusiness: __t.unit(),
  Bootstrapped: __t.unit(),
  SingleLocation: __t.unit(),
  MultiLocation: __t.unit(),
});
export type BusinessManagementStyle = __Infer<typeof BusinessManagementStyle>;

// The tagged union or sum type for the algebraic type `BusinessOwnerDemographics`.
export const BusinessOwnerDemographics = __t.enum("BusinessOwnerDemographics", {
  WomenOwned: __t.unit(),
  LatinxOwned: __t.unit(),
  AsianOwned: __t.unit(),
  BlackOwned: __t.unit(),
  Lgbtq: __t.unit(),
  DisabledOwned: __t.unit(),
  VeteranOwned: __t.unit(),
  ImmigrantOwned: __t.unit(),
  Under35: __t.unit(),
  SerialEntrepreneur: __t.unit(),
  FirstTimeOwner: __t.unit(),
  FirstGenerationOwner: __t.unit(),
});
export type BusinessOwnerDemographics = __Infer<typeof BusinessOwnerDemographics>;

// The tagged union or sum type for the algebraic type `BusinessPhilosophy`.
export const BusinessPhilosophy = __t.enum("BusinessPhilosophy", {
  AmericanMade: __t.unit(),
  Hospitality: __t.unit(),
  ExperientialRetail: __t.unit(),
  EcoFriendly: __t.unit(),
  Artisanal: __t.unit(),
  DigitallyNative: __t.unit(),
  Luxury: __t.unit(),
  ValueDriven: __t.unit(),
  CulturalHeritage: __t.unit(),
});
export type BusinessPhilosophy = __Infer<typeof BusinessPhilosophy>;

// The tagged union or sum type for the algebraic type `BusinessStory`.
export const BusinessStory = __t.enum("BusinessStory", {
  Organic: __t.unit(),
  Invited: __t.unit(),
});
export type BusinessStory = __Infer<typeof BusinessStory>;

export const CalendlyBookingsBrittleV1 = __t.object("CalendlyBookingsBrittleV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  underwritableEntity: __t.u64(),
  eventName: __t.string(),
  startTimestamp: __t.timestamp(),
  endTimestamp: __t.timestamp(),
  eventUri: __t.string(),
  joinUrl: __t.option(__t.string()),
  location: __t.option(__t.string()),
});
export type CalendlyBookingsBrittleV1 = __Infer<typeof CalendlyBookingsBrittleV1>;

export const CalendlyBookingsBrittleV2 = __t.object("CalendlyBookingsBrittleV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  underwritableEntity: __t.uuid(),
  eventName: __t.string(),
  startTimestamp: __t.timestamp(),
  endTimestamp: __t.timestamp(),
  eventUri: __t.string(),
  joinUrl: __t.option(__t.string()),
  location: __t.option(__t.string()),
});
export type CalendlyBookingsBrittleV2 = __Infer<typeof CalendlyBookingsBrittleV2>;

export const CampaignBrowseNominationRow = __t.object("CampaignBrowseNominationRow", {
  id: __t.string(),
  googlePlaceId: __t.string(),
  name: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  get canonicalAddress() {
    return __t.option(CanonicalAddress);
  },
  nominatedByDisplayName: __t.option(__t.string()),
  isClaimed: __t.bool(),
  totalInterested: __t.u32(),
  totalInterestDollars: __t.option(__t.u32()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  createdAt: __t.timestamp(),
});
export type CampaignBrowseNominationRow = __Infer<typeof CampaignBrowseNominationRow>;

export const CampaignBrowseNominations = __t.object("CampaignBrowseNominations", {});
export type CampaignBrowseNominations = __Infer<typeof CampaignBrowseNominations>;

export const CampaignBrowseShareableCardRow = __t.object("CampaignBrowseShareableCardRow", {
  cardId: __t.uuid(),
  brandId: __t.uuid(),
  brandFriendlyName: __t.string(),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  googlePlaceId: __t.option(__t.string()),
  get canonicalAddress() {
    return __t.option(CanonicalAddress);
  },
  hasTtwPageTargetProperty: __t.bool(),
  linkedNominatedBusinessId: __t.option(__t.string()),
  requiresAccessCode: __t.bool(),
  hasTtwPage: __t.bool(),
  totalInterested: __t.u32(),
  totalInterestDollars: __t.u32(),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  createdAt: __t.timestamp(),
  hasOpenOffering: __t.bool(),
  offeringName: __t.string(),
  offeringTargetAmountCents: __t.i64(),
  offeringRaisedCents: __t.i64(),
  offeringInvestorCount: __t.u32(),
  offeringEndDateMs: __t.i64(),
});
export type CampaignBrowseShareableCardRow = __Infer<typeof CampaignBrowseShareableCardRow>;

export const CampaignBrowseShareableCards = __t.object("CampaignBrowseShareableCards", {});
export type CampaignBrowseShareableCards = __Infer<typeof CampaignBrowseShareableCards>;

export const CanonicalAddress = __t.object("CanonicalAddress", {
  addressLine1: __t.string(),
  addressLine2: __t.option(__t.string()),
  city: __t.string(),
  state: __t.string(),
  zip: __t.string(),
  countryCode: __t.string(),
});
export type CanonicalAddress = __Infer<typeof CanonicalAddress>;

export const CardEngineInput = __t.object("CardEngineInput", {
  underwritableEntityId: __t.uuid(),
  get businessStory() {
    return BusinessStory;
  },
  get financialConnections() {
    return FinancialConnections;
  },
  get properties() {
    return __t.array(Property);
  },
  get operatingLocations() {
    return OperatingLocations;
  },
  get underwritingResults() {
    return __t.array(UnderwritingResult);
  },
  get shareableBusinessCards() {
    return __t.array(CardEngineShareableBusinessCardRow);
  },
  get scheduledCalls() {
    return __t.array(CardEngineScheduledCallRow);
  },
});
export type CardEngineInput = __Infer<typeof CardEngineInput>;

export const CardEngineInputs = __t.object("CardEngineInputs", {});
export type CardEngineInputs = __Infer<typeof CardEngineInputs>;

export const CardEngineScheduledCallRow = __t.object("CardEngineScheduledCallRow", {
  id: __t.uuid(),
  underwritableEntity: __t.uuid(),
  eventName: __t.string(),
  startTimestamp: __t.timestamp(),
  endTimestamp: __t.timestamp(),
  joinUrl: __t.option(__t.string()),
  location: __t.option(__t.string()),
});
export type CardEngineScheduledCallRow = __Infer<typeof CardEngineScheduledCallRow>;

export const CardEngineShareableBusinessCardRow = __t.object("CardEngineShareableBusinessCardRow", {
  id: __t.uuid(),
  underwritableEntity: __t.uuid(),
  hasComposerPage: __t.bool(),
  hasTtwPage: __t.bool(),
  ttwFeatureImage: __t.option(__t.string()),
  requiresAccessCode: __t.bool(),
  browsable: __t.bool(),
});
export type CardEngineShareableBusinessCardRow = __Infer<typeof CardEngineShareableBusinessCardRow>;

export const CardPledgeSummary = __t.object("CardPledgeSummary", {
  id: __t.string(),
  displayName: __t.string(),
  dollars: __t.i64(),
  pledgedAt: __t.timestamp(),
  source: __t.string(),
});
export type CardPledgeSummary = __Infer<typeof CardPledgeSummary>;

export const Chart = __t.object("Chart", {
  get type() {
    return ChartType;
  },
  chartLabel: __t.option(__t.string()),
  get unit() {
    return QuestionNumberUnit;
  },
  get data() {
    return Data;
  },
});
export type Chart = __Infer<typeof Chart>;

// The tagged union or sum type for the algebraic type `ChartType`.
export const ChartType = __t.enum("ChartType", {
  Bar: __t.unit(),
  Pie: __t.unit(),
});
export type ChartType = __Infer<typeof ChartType>;

export const CommunityTheaterPledgeRow = __t.object("CommunityTheaterPledgeRow", {
  cardId: __t.uuid(),
  displayName: __t.string(),
  interestDollarAmount: __t.i64(),
  supportiveMessage: __t.option(__t.string()),
});
export type CommunityTheaterPledgeRow = __Infer<typeof CommunityTheaterPledgeRow>;

export const CommunityTheaterPledges = __t.object("CommunityTheaterPledges", {});
export type CommunityTheaterPledges = __Infer<typeof CommunityTheaterPledges>;

export const Comp = __t.object("Comp", {
  id: __t.uuid(),
  get address() {
    return CanonicalAddress;
  },
  imageUrl: __t.option(__t.string()),
  occupiedBy: __t.option(__t.string()),
  isVacant: __t.option(__t.bool()),
  stories: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
  units: __t.option(__t.f64()),
  lastSaleDate: __t.option(__t.string()),
  lastSalePrice: __t.option(__t.f64()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
});
export type Comp = __Infer<typeof Comp>;

export const ComparablePropertiesV1 = __t.object("ComparablePropertiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  get address() {
    return CanonicalAddress;
  },
  addressHash: __t.string(),
  imageUrl: __t.option(__t.string()),
  occupiedBy: __t.option(__t.string()),
  isVacant: __t.option(__t.bool()),
  stories: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
  units: __t.option(__t.f64()),
  lastSaleDate: __t.option(__t.string()),
  lastSalePrice: __t.option(__t.f64()),
});
export type ComparablePropertiesV1 = __Infer<typeof ComparablePropertiesV1>;

export const ComparablePropertiesV2 = __t.object("ComparablePropertiesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  get address() {
    return CanonicalAddress;
  },
  addressHash: __t.string(),
  imageUrl: __t.option(__t.string()),
  occupiedBy: __t.option(__t.string()),
  isVacant: __t.option(__t.bool()),
  stories: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
  units: __t.option(__t.f64()),
  lastSaleDate: __t.option(__t.string()),
  lastSalePrice: __t.option(__t.f64()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
});
export type ComparablePropertiesV2 = __Infer<typeof ComparablePropertiesV2>;

export const ComparablePropertiesV3 = __t.object("ComparablePropertiesV3", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  get address() {
    return CanonicalAddress;
  },
  addressHash: __t.string(),
  imageUrl: __t.option(__t.string()),
  occupiedBy: __t.option(__t.string()),
  isVacant: __t.option(__t.bool()),
  stories: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
  units: __t.option(__t.f64()),
  lastSaleDate: __t.option(__t.string()),
  lastSalePrice: __t.option(__t.f64()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
});
export type ComparablePropertiesV3 = __Infer<typeof ComparablePropertiesV3>;

export const ComparableProperty = __t.object("ComparableProperty", {
  id: __t.uuid(),
  get address() {
    return CanonicalAddress;
  },
  addressHash: __t.string(),
  imageUrl: __t.option(__t.string()),
  occupiedBy: __t.option(__t.string()),
  isVacant: __t.option(__t.bool()),
  stories: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
  units: __t.option(__t.f64()),
  lastSaleDate: __t.option(__t.string()),
  lastSalePrice: __t.option(__t.f64()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
});
export type ComparableProperty = __Infer<typeof ComparableProperty>;

export const CompleteInvitedBrandOnboardingResult = __t.object("CompleteInvitedBrandOnboardingResult", {
  brandId: __t.uuid(),
});
export type CompleteInvitedBrandOnboardingResult = __Infer<typeof CompleteInvitedBrandOnboardingResult>;

export const ComposerAssetUploadUrl = __t.object("ComposerAssetUploadUrl", {
  uploadUrl: __t.string(),
  objectPath: __t.string(),
  contentType: __t.string(),
  contentLengthRange: __t.string(),
});
export type ComposerAssetUploadUrl = __Infer<typeof ComposerAssetUploadUrl>;

export const ComposerChatMessage = __t.object("ComposerChatMessage", {
  role: __t.string(),
  content: __t.string(),
});
export type ComposerChatMessage = __Infer<typeof ComposerChatMessage>;

export const ComposerChatMessagesV1 = __t.object("ComposerChatMessagesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  chat: __t.uuid(),
  role: __t.string(),
  content: __t.string(),
  seq: __t.u32(),
});
export type ComposerChatMessagesV1 = __Infer<typeof ComposerChatMessagesV1>;

export const ComposerChatRow = __t.object("ComposerChatRow", {
  get messages() {
    return __t.array(ComposerChatMessage);
  },
});
export type ComposerChatRow = __Infer<typeof ComposerChatRow>;

export const ComposerChatsV1 = __t.object("ComposerChatsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  clerkUserId: __t.string(),
  title: __t.string(),
});
export type ComposerChatsV1 = __Infer<typeof ComposerChatsV1>;

export const ComposerPageContentRow = __t.object("ComposerPageContentRow", {
  body: __t.string(),
  title: __t.string(),
});
export type ComposerPageContentRow = __Infer<typeof ComposerPageContentRow>;

export const ComposerPagesV1 = __t.object("ComposerPagesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  shareableBusinessCard: __t.uuid(),
  html: __t.string(),
  title: __t.string(),
});
export type ComposerPagesV1 = __Infer<typeof ComposerPagesV1>;

export const ComposerPagesV2 = __t.object("ComposerPagesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  shareableBusinessCard: __t.uuid(),
  blocksJson: __t.string(),
  title: __t.string(),
});
export type ComposerPagesV2 = __Infer<typeof ComposerPagesV2>;

export const ComposerReplyRow = __t.object("ComposerReplyRow", {
  message: __t.string(),
  body: __t.string(),
});
export type ComposerReplyRow = __Infer<typeof ComposerReplyRow>;

export const ComposerTestimonialRow = __t.object("ComposerTestimonialRow", {
  displayName: __t.string(),
  quote: __t.string(),
});
export type ComposerTestimonialRow = __Infer<typeof ComposerTestimonialRow>;

export const ComposerTestimonialsRow = __t.object("ComposerTestimonialsRow", {
  get testimonials() {
    return __t.array(ComposerTestimonialRow);
  },
});
export type ComposerTestimonialsRow = __Infer<typeof ComposerTestimonialsRow>;

export const CompsWebhookScheduleV1 = __t.object("CompsWebhookScheduleV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  id: __t.string(),
  brand: __t.uuid(),
  underwritableEntity: __t.uuid(),
  targetableProperty: __t.uuid(),
});
export type CompsWebhookScheduleV1 = __Infer<typeof CompsWebhookScheduleV1>;

export const CreateInvestorTransactAccountResult = __t.object("CreateInvestorTransactAccountResult", {
  partyId: __t.string(),
  accountId: __t.string(),
  linkId: __t.string(),
});
export type CreateInvestorTransactAccountResult = __Infer<typeof CreateInvestorTransactAccountResult>;

export const CreatedShareableBusinessCardRow = __t.object("CreatedShareableBusinessCardRow", {
  id: __t.uuid(),
});
export type CreatedShareableBusinessCardRow = __Infer<typeof CreatedShareableBusinessCardRow>;

export const CurrentUser = __t.object("CurrentUser", {});
export type CurrentUser = __Infer<typeof CurrentUser>;

export const CurrentUserInfo = __t.object("CurrentUserInfo", {});
export type CurrentUserInfo = __Infer<typeof CurrentUserInfo>;

export const CurrentUserInfoRow = __t.object("CurrentUserInfoRow", {
  firstName: __t.option(__t.string()),
  lastName: __t.option(__t.string()),
  phone: __t.option(__t.string()),
  dob: __t.option(__t.string()),
  citizenship: __t.option(__t.string()),
  residency: __t.option(__t.string()),
  get address() {
    return __t.option(CanonicalAddress);
  },
  avatarCdnPath: __t.option(__t.string()),
  isAccreditedInvestor: __t.option(__t.bool()),
});
export type CurrentUserInfoRow = __Infer<typeof CurrentUserInfoRow>;

export const CurrentUserRow = __t.object("CurrentUserRow", {
  clerkUserId: __t.string(),
  email: __t.string(),
  firstName: __t.option(__t.string()),
  lastName: __t.option(__t.string()),
  avatarCdnPath: __t.option(__t.string()),
  isWithcoEmployee: __t.bool(),
  brandIds: __t.array(__t.uuid()),
  investorIds: __t.array(__t.uuid()),
});
export type CurrentUserRow = __Infer<typeof CurrentUserRow>;

export const Data = __t.object("Data", {
  labels: __t.array(__t.string()),
  values: __t.array(__t.array(__t.f64())),
});
export type Data = __Infer<typeof Data>;

export const ExternalFundMoveOperationsV1 = __t.object("ExternalFundMoveOperationsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  tradeId: __t.string(),
  accountId: __t.string(),
  status: __t.string(),
  params: __t.string(),
  error: __t.option(__t.string()),
});
export type ExternalFundMoveOperationsV1 = __Infer<typeof ExternalFundMoveOperationsV1>;

export const FeatureFlagsV1 = __t.object("FeatureFlagsV1", {
  key: __t.string(),
  enabled: __t.bool(),
  updatedBy: __t.string(),
});
export type FeatureFlagsV1 = __Infer<typeof FeatureFlagsV1>;

export const FeatureFlagsView = __t.object("FeatureFlagsView", {});
export type FeatureFlagsView = __Infer<typeof FeatureFlagsView>;

export const FetchCompsJobScheduledItemsV1 = __t.object("FetchCompsJobScheduledItemsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  id: __t.string(),
  underwritableEntityV1: __t.u64(),
  targetablePropertyV1: __t.u64(),
});
export type FetchCompsJobScheduledItemsV1 = __Infer<typeof FetchCompsJobScheduledItemsV1>;

export const FetchCompsJobScheduledItemsV2 = __t.object("FetchCompsJobScheduledItemsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  id: __t.string(),
  underwritableEntity: __t.uuid(),
  targetableProperty: __t.uuid(),
});
export type FetchCompsJobScheduledItemsV2 = __Infer<typeof FetchCompsJobScheduledItemsV2>;

// The tagged union or sum type for the algebraic type `FetchCompsJobStatusV1`.
export const FetchCompsJobStatusV1 = __t.enum("FetchCompsJobStatusV1", {
  Pending: __t.unit(),
  Complete: __t.unit(),
  NoResults: __t.unit(),
  Failed: __t.unit(),
  TimedOut: __t.unit(),
});
export type FetchCompsJobStatusV1 = __Infer<typeof FetchCompsJobStatusV1>;

export const FetchCompsJobsV1 = __t.object("FetchCompsJobsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  id: __t.string(),
  underwritableEntityV1: __t.u64(),
  targetablePropertyV1: __t.u64(),
  brandV1: __t.u64(),
  get status() {
    return FetchCompsJobStatusV1;
  },
  attempts: __t.u8(),
  lastPolledAt: __t.option(__t.timestamp()),
  completedAt: __t.option(__t.timestamp()),
  errorKind: __t.option(__t.string()),
  errorMessage: __t.option(__t.string()),
});
export type FetchCompsJobsV1 = __Infer<typeof FetchCompsJobsV1>;

export const FetchOperatingPropertiesJobScheduledItemsV1 = __t.object("FetchOperatingPropertiesJobScheduledItemsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  brandV1: __t.uuid(),
});
export type FetchOperatingPropertiesJobScheduledItemsV1 = __Infer<typeof FetchOperatingPropertiesJobScheduledItemsV1>;

// The tagged union or sum type for the algebraic type `FetchOperatingPropertiesJobStatusV1`.
export const FetchOperatingPropertiesJobStatusV1 = __t.enum("FetchOperatingPropertiesJobStatusV1", {
  Pending: __t.unit(),
  Complete: __t.unit(),
  NoResults: __t.unit(),
  Failed: __t.unit(),
  TimedOut: __t.unit(),
});
export type FetchOperatingPropertiesJobStatusV1 = __Infer<typeof FetchOperatingPropertiesJobStatusV1>;

export const FetchOperatingPropertiesJobsV1 = __t.object("FetchOperatingPropertiesJobsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  id: __t.string(),
  brandV1: __t.u64(),
  get status() {
    return FetchOperatingPropertiesJobStatusV1;
  },
  started: __t.bool(),
  attempts: __t.u8(),
  lastPolledAt: __t.option(__t.timestamp()),
  completedAt: __t.option(__t.timestamp()),
  errorKind: __t.option(__t.string()),
  errorMessage: __t.option(__t.string()),
});
export type FetchOperatingPropertiesJobsV1 = __Infer<typeof FetchOperatingPropertiesJobsV1>;

export const FetchOperatingPropertiesJobsV2 = __t.object("FetchOperatingPropertiesJobsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  id: __t.string(),
  brand: __t.uuid(),
  get status() {
    return FetchOperatingPropertiesJobStatusV1;
  },
  started: __t.bool(),
  attempts: __t.u8(),
  lastPolledAt: __t.option(__t.timestamp()),
  completedAt: __t.option(__t.timestamp()),
  errorKind: __t.option(__t.string()),
  errorMessage: __t.option(__t.string()),
});
export type FetchOperatingPropertiesJobsV2 = __Infer<typeof FetchOperatingPropertiesJobsV2>;

// The tagged union or sum type for the algebraic type `FetchUnderwritingResultsJobStatusV1`.
export const FetchUnderwritingResultsJobStatusV1 = __t.enum("FetchUnderwritingResultsJobStatusV1", {
  Pending: __t.unit(),
  Complete: __t.unit(),
  Failed: __t.unit(),
  TimedOut: __t.unit(),
});
export type FetchUnderwritingResultsJobStatusV1 = __Infer<typeof FetchUnderwritingResultsJobStatusV1>;

export const FetchUnderwritingResultsJobsV1 = __t.object("FetchUnderwritingResultsJobsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  id: __t.string(),
  underwritableEntityV1: __t.u64(),
  brandV1: __t.u64(),
  get status() {
    return FetchUnderwritingResultsJobStatusV1;
  },
  attempts: __t.u8(),
  lastPolledAt: __t.option(__t.timestamp()),
  completedAt: __t.option(__t.timestamp()),
  errorKind: __t.option(__t.string()),
  errorMessage: __t.option(__t.string()),
});
export type FetchUnderwritingResultsJobsV1 = __Infer<typeof FetchUnderwritingResultsJobsV1>;

export const FetchUnderwritingResultsJobsV2 = __t.object("FetchUnderwritingResultsJobsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  id: __t.string(),
  underwritableEntity: __t.uuid(),
  brand: __t.uuid(),
  get status() {
    return FetchUnderwritingResultsJobStatusV1;
  },
  attempts: __t.u8(),
  lastPolledAt: __t.option(__t.timestamp()),
  completedAt: __t.option(__t.timestamp()),
  errorKind: __t.option(__t.string()),
  errorMessage: __t.option(__t.string()),
});
export type FetchUnderwritingResultsJobsV2 = __Infer<typeof FetchUnderwritingResultsJobsV2>;

export const FinancialConnections = __t.object("FinancialConnections", {
  get accounting() {
    return __t.array(AccountingConnection);
  },
  get banking() {
    return __t.array(BankingConnection);
  },
  get pos() {
    return __t.array(PosConnection);
  },
  payroll: __t.array(__t.string()),
  get taxReturns() {
    return __t.array(TaxReturnConnection);
  },
  get leases() {
    return __t.array(LeaseConnection);
  },
});
export type FinancialConnections = __Infer<typeof FinancialConnections>;

export const FirstMatchingNomination = __t.object("FirstMatchingNomination", {});
export type FirstMatchingNomination = __Infer<typeof FirstMatchingNomination>;

export const FirstMatchingNominationRow = __t.object("FirstMatchingNominationRow", {
  id: __t.string(),
  googlePlaceId: __t.option(__t.string()),
  name: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  nominatedByClerkUserIdV1: __t.option(__t.string()),
  totalInterested: __t.u32(),
  get canonicalAddress() {
    return __t.option(CanonicalAddress);
  },
  submittedClaimRequest: __t.bool(),
});
export type FirstMatchingNominationRow = __Infer<typeof FirstMatchingNominationRow>;

export const FreeformAnswer = __t.object("FreeformAnswer", {
  value: __t.string(),
  note: __t.option(__t.string()),
});
export type FreeformAnswer = __Infer<typeof FreeformAnswer>;

export const FreeformQuestionWithAnswer = __t.object("FreeformQuestionWithAnswer", {
  id: __t.string(),
  title: __t.string(),
  subtitle: __t.option(__t.string()),
  get details() {
    return __t.option(QuestionDetails);
  },
  get lengthUnit() {
    return LengthUnit;
  },
  minLength: __t.option(__t.f64()),
  maxLength: __t.option(__t.f64()),
  get answer() {
    return __t.option(FreeformAnswer);
  },
});
export type FreeformQuestionWithAnswer = __Infer<typeof FreeformQuestionWithAnswer>;

export const FundingSourceRow = __t.object("FundingSourceRow", {
  externalAccountId: __t.string(),
  nickname: __t.option(__t.string()),
});
export type FundingSourceRow = __Infer<typeof FundingSourceRow>;

export const FundingSourcesV1 = __t.object("FundingSourcesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  externalAccountId: __t.string(),
  investor: __t.string(),
  transactAccountId: __t.string(),
  nickname: __t.option(__t.string()),
});
export type FundingSourcesV1 = __Infer<typeof FundingSourcesV1>;

export const FundingSourcesV2 = __t.object("FundingSourcesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  transactAccountId: __t.string(),
  investor: __t.string(),
  externalAccountId: __t.option(__t.string()),
  nickname: __t.option(__t.string()),
  externalAccountIdIsAuthoritative: __t.bool(),
});
export type FundingSourcesV2 = __Infer<typeof FundingSourcesV2>;

export const HeroUploadUrl = __t.object("HeroUploadUrl", {
  uploadUrl: __t.string(),
  objectPath: __t.string(),
  contentType: __t.string(),
  contentLengthRange: __t.string(),
});
export type HeroUploadUrl = __Infer<typeof HeroUploadUrl>;

export const IngestLeaseDocsResult = __t.object("IngestLeaseDocsResult", {
  accepted: __t.bool(),
  leaseDocsCreated: __t.i32(),
  reason: __t.option(__t.string()),
});
export type IngestLeaseDocsResult = __Infer<typeof IngestLeaseDocsResult>;

export const IngestedEmailIdsV1 = __t.object("IngestedEmailIdsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  emailId: __t.string(),
  ingestedAt: __t.timestamp(),
});
export type IngestedEmailIdsV1 = __Infer<typeof IngestedEmailIdsV1>;

export const InvestorDashboard = __t.object("InvestorDashboard", {});
export type InvestorDashboard = __Infer<typeof InvestorDashboard>;

export const InvestorDashboardRow = __t.object("InvestorDashboardRow", {
  get pledgedCards() {
    return __t.array(InvestorPledgedCardRow);
  },
  get transactAccount() {
    return __t.option(InvestorTransactAccountRow);
  },
  get investments() {
    return __t.array(InvestorInvestmentRow);
  },
  get nominatedBusinesses() {
    return __t.array(InvestorNominatedBusinessRow);
  },
  get pledgedNominations() {
    return __t.array(InvestorPledgedNominationRow);
  },
});
export type InvestorDashboardRow = __Infer<typeof InvestorDashboardRow>;

export const InvestorInvestmentRow = __t.object("InvestorInvestmentRow", {
  orderId: __t.string(),
  cardId: __t.option(__t.string()),
  brandFriendlyName: __t.string(),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  offeringName: __t.string(),
  amountCents: __t.i64(),
  status: __t.string(),
  transactionInitiatedAtMs: __t.option(__t.i64()),
  hasError: __t.bool(),
  businessType: __t.option(__t.string()),
  offeringTargetAmountCents: __t.i64(),
  offeringRaisedCents: __t.i64(),
  offeringInvestorCount: __t.u32(),
});
export type InvestorInvestmentRow = __Infer<typeof InvestorInvestmentRow>;

export const InvestorNominatedBusinessRow = __t.object("InvestorNominatedBusinessRow", {
  nominatedBusinessId: __t.string(),
  name: __t.string(),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  totalInterested: __t.u32(),
});
export type InvestorNominatedBusinessRow = __Infer<typeof InvestorNominatedBusinessRow>;

export const InvestorPledgedCardRow = __t.object("InvestorPledgedCardRow", {
  cardId: __t.uuid(),
  brandFriendlyName: __t.string(),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  interestDollarAmount: __t.i64(),
  supportiveMessage: __t.option(__t.string()),
  totalInterested: __t.u32(),
  hasTtwPage: __t.bool(),
});
export type InvestorPledgedCardRow = __Infer<typeof InvestorPledgedCardRow>;

export const InvestorPledgedNominationRow = __t.object("InvestorPledgedNominationRow", {
  nominatedBusinessId: __t.string(),
  name: __t.string(),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  interestDollarAmount: __t.i64(),
  supportiveMessage: __t.option(__t.string()),
  totalInterested: __t.u32(),
});
export type InvestorPledgedNominationRow = __Infer<typeof InvestorPledgedNominationRow>;

export const InvestorTransactAccountRow = __t.object("InvestorTransactAccountRow", {
  partyId: __t.string(),
  accountId: __t.string(),
  linkId: __t.string(),
});
export type InvestorTransactAccountRow = __Infer<typeof InvestorTransactAccountRow>;

export const InvestorTransactAccountsV1 = __t.object("InvestorTransactAccountsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  clerkUserId: __t.string(),
  partyId: __t.string(),
  accountId: __t.string(),
  linkId: __t.string(),
});
export type InvestorTransactAccountsV1 = __Infer<typeof InvestorTransactAccountsV1>;

export const InvestorsToUsersV1 = __t.object("InvestorsToUsersV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  investorV1: __t.u64(),
  clerkUserIdV1: __t.string(),
});
export type InvestorsToUsersV1 = __Infer<typeof InvestorsToUsersV1>;

export const InvestorsToUsersV2 = __t.object("InvestorsToUsersV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  investor: __t.uuid(),
  clerkUserId: __t.string(),
});
export type InvestorsToUsersV2 = __Infer<typeof InvestorsToUsersV2>;

export const InvestorsV1 = __t.object("InvestorsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  isAccredited: __t.option(__t.bool()),
});
export type InvestorsV1 = __Infer<typeof InvestorsV1>;

export const InvestorsV2 = __t.object("InvestorsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  isAccredited: __t.option(__t.bool()),
});
export type InvestorsV2 = __Infer<typeof InvestorsV2>;

export const InvitedBrandDraftRow = __t.object("InvitedBrandDraftRow", {
  id: __t.uuid(),
  publicCode: __t.string(),
  email: __t.string(),
  get status() {
    return InvitedBrandDraftStatus;
  },
  createdByClerkUserId: __t.string(),
  boundClerkUserId: __t.option(__t.string()),
  expiresAt: __t.timestamp(),
  businessGooglePlaceId: __t.string(),
  businessGooglePlacePhotoName: __t.option(__t.string()),
  businessName: __t.string(),
  get businessAddress() {
    return CanonicalAddress;
  },
  businessCategory: __t.string(),
  businessType: __t.string(),
  websiteUrl: __t.option(__t.string()),
  businessTags: __t.array(__t.string()),
  get targetPropertyAddress() {
    return CanonicalAddress;
  },
  targetPropertyLatitude: __t.option(__t.f64()),
  targetPropertyLongitude: __t.option(__t.f64()),
  claimedBrand: __t.option(__t.uuid()),
  claimedAt: __t.option(__t.timestamp()),
  initialPriceEstimate: __t.option(__t.f64()),
});
export type InvitedBrandDraftRow = __Infer<typeof InvitedBrandDraftRow>;

// The tagged union or sum type for the algebraic type `InvitedBrandDraftStatus`.
export const InvitedBrandDraftStatus = __t.enum("InvitedBrandDraftStatus", {
  Pending: __t.unit(),
  Claimed: __t.unit(),
  Revoked: __t.unit(),
  Expired: __t.unit(),
});
export type InvitedBrandDraftStatus = __Infer<typeof InvitedBrandDraftStatus>;

export const InvitedBrandDraftsV1 = __t.object("InvitedBrandDraftsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  publicCode: __t.string(),
  idempotencyKey: __t.string(),
  email: __t.string(),
  get status() {
    return InvitedBrandDraftStatus;
  },
  createdByClerkUserId: __t.string(),
  boundClerkUserId: __t.option(__t.string()),
  expiresAt: __t.timestamp(),
  businessGooglePlaceId: __t.string(),
  businessGooglePlacePhotoName: __t.option(__t.string()),
  businessName: __t.string(),
  get businessAddress() {
    return CanonicalAddress;
  },
  businessCategory: __t.string(),
  businessType: __t.string(),
  websiteUrl: __t.option(__t.string()),
  businessTags: __t.array(__t.string()),
  get targetPropertyAddress() {
    return CanonicalAddress;
  },
  targetPropertyLatitude: __t.option(__t.f64()),
  targetPropertyLongitude: __t.option(__t.f64()),
  claimedBrand: __t.option(__t.uuid()),
  claimedAt: __t.option(__t.timestamp()),
  initialPriceEstimate: __t.option(__t.f64()),
});
export type InvitedBrandDraftsV1 = __Infer<typeof InvitedBrandDraftsV1>;

export const InvitedBrandEmailScheduleV1 = __t.object("InvitedBrandEmailScheduleV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  draft: __t.uuid(),
  attempts: __t.u32(),
});
export type InvitedBrandEmailScheduleV1 = __Infer<typeof InvitedBrandEmailScheduleV1>;

// The tagged union or sum type for the algebraic type `InvitedOnboardingStep`.
export const InvitedOnboardingStep = __t.enum("InvitedOnboardingStep", {
  Customize: __t.unit(),
  Supplemental: __t.unit(),
  UserInfo: __t.unit(),
});
export type InvitedOnboardingStep = __Infer<typeof InvitedOnboardingStep>;

export const LandlordNegotiationFormRow = __t.object("LandlordNegotiationFormRow", {
  tenantName: __t.string(),
  shortAddress: __t.string(),
  get saleType() {
    return __t.option(LandlordSaleTypeV1);
  },
  minPurchasePrice: __t.option(__t.f64()),
  fairPurchasePrice: __t.option(__t.f64()),
  usdCashOut: __t.option(__t.f64()),
  usdMonthlyDividend: __t.option(__t.f64()),
  percentAnnualRentalYield: __t.option(__t.f64()),
  submittedAt: __t.option(__t.timestamp()),
});
export type LandlordNegotiationFormRow = __Infer<typeof LandlordNegotiationFormRow>;

export const LandlordNegotiationFormsV1 = __t.object("LandlordNegotiationFormsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  underwritableEntityV1: __t.u64(),
  targetablePropertyV1: __t.u64(),
  accessCode: __t.string(),
  get saleType() {
    return __t.option(LandlordSaleTypeV1);
  },
  minPurchasePrice: __t.option(__t.f64()),
  fairPurchasePrice: __t.option(__t.f64()),
  usdCashOut: __t.option(__t.f64()),
  usdMonthlyDividend: __t.option(__t.f64()),
  percentAnnualRentalYield: __t.option(__t.f64()),
  submittedAt: __t.option(__t.timestamp()),
});
export type LandlordNegotiationFormsV1 = __Infer<typeof LandlordNegotiationFormsV1>;

export const LandlordNegotiationFormsV2 = __t.object("LandlordNegotiationFormsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  underwritableEntity: __t.uuid(),
  targetableProperty: __t.uuid(),
  accessCode: __t.string(),
  get saleType() {
    return __t.option(LandlordSaleTypeV1);
  },
  minPurchasePrice: __t.option(__t.f64()),
  fairPurchasePrice: __t.option(__t.f64()),
  usdCashOut: __t.option(__t.f64()),
  usdMonthlyDividend: __t.option(__t.f64()),
  percentAnnualRentalYield: __t.option(__t.f64()),
  submittedAt: __t.option(__t.timestamp()),
});
export type LandlordNegotiationFormsV2 = __Infer<typeof LandlordNegotiationFormsV2>;

// The tagged union or sum type for the algebraic type `LandlordSaleTypeV1`.
export const LandlordSaleTypeV1 = __t.enum("LandlordSaleTypeV1", {
  Partial: __t.unit(),
  Full: __t.unit(),
});
export type LandlordSaleTypeV1 = __Infer<typeof LandlordSaleTypeV1>;

// The tagged union or sum type for the algebraic type `LandlordSubmitDataV1`.
export const LandlordSubmitDataV1 = __t.enum("LandlordSubmitDataV1", {
  get Full() {
    return LandlordSubmitFullV1;
  },
  get Partial() {
    return LandlordSubmitPartialV1;
  },
});
export type LandlordSubmitDataV1 = __Infer<typeof LandlordSubmitDataV1>;

export const LandlordSubmitFullV1 = __t.object("LandlordSubmitFullV1", {
  minPurchasePrice: __t.f64(),
  fairPurchasePrice: __t.f64(),
});
export type LandlordSubmitFullV1 = __Infer<typeof LandlordSubmitFullV1>;

export const LandlordSubmitPartialV1 = __t.object("LandlordSubmitPartialV1", {
  usdCashOut: __t.f64(),
  usdMonthlyDividend: __t.f64(),
  percentAnnualRentalYield: __t.f64(),
});
export type LandlordSubmitPartialV1 = __Infer<typeof LandlordSubmitPartialV1>;

export const LeaseConnection = __t.object("LeaseConnection", {
  id: __t.string(),
  originalFileName: __t.string(),
});
export type LeaseConnection = __Infer<typeof LeaseConnection>;

export const LeaseDocDataSync = __t.object("LeaseDocDataSync", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  leaseDocV1: __t.u64(),
  underwritableEntityV1: __t.u64(),
});
export type LeaseDocDataSync = __Infer<typeof LeaseDocDataSync>;

export const LeaseDocEmailRequest = __t.object("LeaseDocEmailRequest", {
  sentToEmail: __t.string(),
});
export type LeaseDocEmailRequest = __Infer<typeof LeaseDocEmailRequest>;

export const LeaseDocForUserRow = __t.object("LeaseDocForUserRow", {
  id: __t.uuid(),
  originalFileName: __t.string(),
  createdAt: __t.timestamp(),
});
export type LeaseDocForUserRow = __Infer<typeof LeaseDocForUserRow>;

export const LeaseDocScheduledItemsV2 = __t.object("LeaseDocScheduledItemsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  leaseDoc: __t.uuid(),
  underwritableEntity: __t.uuid(),
});
export type LeaseDocScheduledItemsV2 = __Infer<typeof LeaseDocScheduledItemsV2>;

export const LeaseDocUploadUrl = __t.object("LeaseDocUploadUrl", {
  uploadUrl: __t.string(),
  objectPath: __t.string(),
  contentType: __t.string(),
  contentLengthRange: __t.string(),
});
export type LeaseDocUploadUrl = __Infer<typeof LeaseDocUploadUrl>;

export const LeaseDocsToUnderwritableEntitiesV1 = __t.object("LeaseDocsToUnderwritableEntitiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  leaseDocV1: __t.u64(),
  underwritableEntityV1: __t.u64(),
});
export type LeaseDocsToUnderwritableEntitiesV1 = __Infer<typeof LeaseDocsToUnderwritableEntitiesV1>;

export const LeaseDocsToUnderwritableEntitiesV2 = __t.object("LeaseDocsToUnderwritableEntitiesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  leaseDoc: __t.uuid(),
  underwritableEntity: __t.uuid(),
});
export type LeaseDocsToUnderwritableEntitiesV2 = __Infer<typeof LeaseDocsToUnderwritableEntitiesV2>;

export const LeaseDocsV1 = __t.object("LeaseDocsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  originalFileName: __t.string(),
  gcsUri: __t.string(),
  get jobStatus() {
    return AthenaAsyncStatusFieldsJobStatus;
  },
  error: __t.option(__t.string()),
});
export type LeaseDocsV1 = __Infer<typeof LeaseDocsV1>;

export const LeaseDocsV2 = __t.object("LeaseDocsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  originalFileName: __t.string(),
  gcsUri: __t.string(),
  get jobStatus() {
    return AthenaAsyncStatusFieldsJobStatus;
  },
  error: __t.option(__t.string()),
});
export type LeaseDocsV2 = __Infer<typeof LeaseDocsV2>;

export const LeaseEmailUploadReqsV1 = __t.object("LeaseEmailUploadReqsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  code: __t.string(),
  underwritableEntityV1: __t.u64(),
  requestedByClerkUserIdV1: __t.string(),
  requestedByEmail: __t.string(),
  expiresAt: __t.timestamp(),
  consumedCount: __t.i32(),
});
export type LeaseEmailUploadReqsV1 = __Infer<typeof LeaseEmailUploadReqsV1>;

export const LeaseEmailUploadReqsV2 = __t.object("LeaseEmailUploadReqsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  code: __t.string(),
  underwritableEntity: __t.uuid(),
  requestedByClerkUserId: __t.string(),
  requestedByEmail: __t.string(),
  expiresAt: __t.timestamp(),
  consumedCount: __t.i32(),
});
export type LeaseEmailUploadReqsV2 = __Infer<typeof LeaseEmailUploadReqsV2>;

export const LeaseGraderAbstractsV1 = __t.object("LeaseGraderAbstractsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  sessionId: __t.string(),
  clerkUserId: __t.option(__t.string()),
  docId: __t.option(__t.string()),
  gcsUri: __t.option(__t.string()),
  originalFileName: __t.option(__t.string()),
  address: __t.option(__t.string()),
  rentableSquareFeet: __t.option(__t.string()),
  leaseStart: __t.option(__t.string()),
  leaseExpiration: __t.option(__t.string()),
  monthlyRent: __t.option(__t.string()),
  rentEscalation: __t.option(__t.string()),
  expenseResponsibility: __t.option(__t.string()),
  renewalOptions: __t.option(__t.string()),
  purchaseOption: __t.option(__t.string()),
  terminationOption: __t.option(__t.string()),
  rentAmount: __t.option(__t.string()),
  rentPeriod: __t.option(__t.string()),
  squareFeetAmount: __t.option(__t.string()),
  expenseBasis: __t.option(__t.string()),
  purchaseOptionType: __t.option(__t.string()),
  terminationOptionType: __t.option(__t.string()),
  healthLevel: __t.option(__t.string()),
  runway: __t.option(__t.string()),
  monthsToExpiry: __t.option(__t.string()),
  advantages: __t.option(__t.string()),
  disadvantages: __t.option(__t.string()),
});
export type LeaseGraderAbstractsV1 = __Infer<typeof LeaseGraderAbstractsV1>;

export const LeaseGraderChatMessage = __t.object("LeaseGraderChatMessage", {
  role: __t.string(),
  content: __t.string(),
});
export type LeaseGraderChatMessage = __Infer<typeof LeaseGraderChatMessage>;

export const LeaseGraderChatMessagesV1 = __t.object("LeaseGraderChatMessagesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  chat: __t.uuid(),
  role: __t.string(),
  content: __t.string(),
  seq: __t.u32(),
});
export type LeaseGraderChatMessagesV1 = __Infer<typeof LeaseGraderChatMessagesV1>;

export const LeaseGraderChatRow = __t.object("LeaseGraderChatRow", {
  get messages() {
    return __t.array(LeaseGraderChatMessage);
  },
});
export type LeaseGraderChatRow = __Infer<typeof LeaseGraderChatRow>;

export const LeaseGraderChatsV1 = __t.object("LeaseGraderChatsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  sessionId: __t.string(),
  title: __t.string(),
});
export type LeaseGraderChatsV1 = __Infer<typeof LeaseGraderChatsV1>;

export const LeaseGraderDocRow = __t.object("LeaseGraderDocRow", {
  originalFileName: __t.string(),
});
export type LeaseGraderDocRow = __Infer<typeof LeaseGraderDocRow>;

export const LeaseGraderDocsV1 = __t.object("LeaseGraderDocsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  sessionId: __t.string(),
  gcsUri: __t.string(),
  originalFileName: __t.string(),
});
export type LeaseGraderDocsV1 = __Infer<typeof LeaseGraderDocsV1>;

export const LeaseGraderDocumentInput = __t.object("LeaseGraderDocumentInput", {
  fileName: __t.string(),
  base64: __t.string(),
});
export type LeaseGraderDocumentInput = __Infer<typeof LeaseGraderDocumentInput>;

export const LeaseGraderOfferResultsV1 = __t.object("LeaseGraderOfferResultsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  sessionId: __t.string(),
  clerkUserId: __t.option(__t.string()),
  docId: __t.option(__t.string()),
  gcsUri: __t.option(__t.string()),
  originalFileName: __t.option(__t.string()),
  address: __t.option(__t.string()),
  rentableSquareFeet: __t.option(__t.string()),
  leaseStart: __t.option(__t.string()),
  leaseExpiration: __t.option(__t.string()),
  monthlyRent: __t.option(__t.string()),
  rentEscalation: __t.option(__t.string()),
  expenseResponsibility: __t.option(__t.string()),
  renewalOptions: __t.option(__t.string()),
  purchaseOption: __t.option(__t.string()),
  terminationOption: __t.option(__t.string()),
  rentAmount: __t.option(__t.string()),
  rentPeriod: __t.option(__t.string()),
  squareFeetAmount: __t.option(__t.string()),
  buildingSquareFeetAmount: __t.option(__t.string()),
  expenseBasis: __t.option(__t.string()),
  purchaseOptionType: __t.option(__t.string()),
  terminationOptionType: __t.option(__t.string()),
  occupiesMajority: __t.option(__t.string()),
  offerStatus: __t.option(__t.string()),
  flags: __t.option(__t.string()),
  marketLabel: __t.option(__t.string()),
  contractRentPsf: __t.option(__t.string()),
  marketRentPsf: __t.option(__t.string()),
  rentDelta: __t.option(__t.string()),
  incomeCapValue: __t.option(__t.string()),
  marketValue: __t.option(__t.string()),
  suggestedOfferPrice: __t.option(__t.string()),
  offerBasis: __t.option(__t.string()),
  offerSquareFeet: __t.option(__t.string()),
  effectiveMonthlyCostOfOwning: __t.option(__t.string()),
  currentMonthlyRent: __t.option(__t.string()),
  ownershipCostsMore: __t.option(__t.string()),
  rationale: __t.option(__t.string()),
});
export type LeaseGraderOfferResultsV1 = __Infer<typeof LeaseGraderOfferResultsV1>;

export const LeaseGraderOptionsV1 = __t.object("LeaseGraderOptionsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  sessionId: __t.string(),
  clerkUserId: __t.option(__t.string()),
  docId: __t.option(__t.string()),
  gcsUri: __t.option(__t.string()),
  originalFileName: __t.option(__t.string()),
  address: __t.option(__t.string()),
  rentableSquareFeet: __t.option(__t.string()),
  leaseStart: __t.option(__t.string()),
  leaseExpiration: __t.option(__t.string()),
  monthlyRent: __t.option(__t.string()),
  rentEscalation: __t.option(__t.string()),
  expenseResponsibility: __t.option(__t.string()),
  renewalOptions: __t.option(__t.string()),
  purchaseOption: __t.option(__t.string()),
  terminationOption: __t.option(__t.string()),
  rentAmount: __t.option(__t.string()),
  rentPeriod: __t.option(__t.string()),
  rentAtExpiryAmount: __t.option(__t.string()),
  rentAtExpiryPeriod: __t.option(__t.string()),
  squareFeetAmount: __t.option(__t.string()),
  buildingSquareFeetAmount: __t.option(__t.string()),
  expenseBasis: __t.option(__t.string()),
  purchaseOptionType: __t.option(__t.string()),
  terminationOptionType: __t.option(__t.string()),
  likesSpace: __t.option(__t.string()),
  occupiesMajority: __t.option(__t.string()),
  optionsStatus: __t.option(__t.string()),
  optionKinds: __t.option(__t.string()),
  disclaimers: __t.option(__t.string()),
  marketLabel: __t.option(__t.string()),
  contractRentPsf: __t.option(__t.string()),
  marketRentPsf: __t.option(__t.string()),
  rentDeltaToday: __t.option(__t.string()),
  contractRentAtExpiryPsf: __t.option(__t.string()),
  marketRentAtExpiryPsf: __t.option(__t.string()),
  rentDeltaAtExpiry: __t.option(__t.string()),
  rentAtExpiryFromLease: __t.option(__t.string()),
  monthsToExpiry: __t.option(__t.string()),
  canExitSoon: __t.option(__t.string()),
  suggestedOfferPrice: __t.option(__t.string()),
  offerBasis: __t.option(__t.string()),
  monthlyCostOfOwning: __t.option(__t.string()),
  ownershipOpportunity: __t.option(__t.string()),
  rationale: __t.option(__t.string()),
});
export type LeaseGraderOptionsV1 = __Infer<typeof LeaseGraderOptionsV1>;

export const LeaseGraderReplyRow = __t.object("LeaseGraderReplyRow", {
  message: __t.string(),
  confirmation: __t.string(),
});
export type LeaseGraderReplyRow = __Infer<typeof LeaseGraderReplyRow>;

export const LeaseGraderResultsV1 = __t.object("LeaseGraderResultsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  sessionId: __t.string(),
  clerkUserId: __t.option(__t.string()),
  docId: __t.option(__t.string()),
  gcsUri: __t.option(__t.string()),
  originalFileName: __t.option(__t.string()),
  address: __t.option(__t.string()),
  rentableSquareFeet: __t.option(__t.string()),
  leaseStart: __t.option(__t.string()),
  leaseExpiration: __t.option(__t.string()),
  monthlyRent: __t.option(__t.string()),
  rentEscalation: __t.option(__t.string()),
  expenseResponsibility: __t.option(__t.string()),
  renewalOptions: __t.option(__t.string()),
  purchaseOption: __t.option(__t.string()),
  terminationOption: __t.option(__t.string()),
  rentAmount: __t.option(__t.string()),
  rentPeriod: __t.option(__t.string()),
  squareFeetAmount: __t.option(__t.string()),
  expenseBasis: __t.option(__t.string()),
  purchaseOptionType: __t.option(__t.string()),
  terminationOptionType: __t.option(__t.string()),
  likesSpace: __t.option(__t.string()),
  occupiesMajority: __t.option(__t.string()),
  recommendationStatus: __t.option(__t.string()),
  verdict: __t.option(__t.string()),
  urgency: __t.option(__t.string()),
  flags: __t.option(__t.string()),
  marketLabel: __t.option(__t.string()),
  contractRentPsf: __t.option(__t.string()),
  marketRentPsf: __t.option(__t.string()),
  rentDelta: __t.option(__t.string()),
  monthsToExpiry: __t.option(__t.string()),
  incomeCapValue: __t.option(__t.string()),
  marketValue: __t.option(__t.string()),
  suggestedOfferPrice: __t.option(__t.string()),
  suggestedOfferBasis: __t.option(__t.string()),
  rationale: __t.option(__t.string()),
});
export type LeaseGraderResultsV1 = __Infer<typeof LeaseGraderResultsV1>;

export const LeaseGraderUploadUrl = __t.object("LeaseGraderUploadUrl", {
  uploadUrl: __t.string(),
  objectPath: __t.string(),
  contentType: __t.string(),
  contentLengthRange: __t.string(),
});
export type LeaseGraderUploadUrl = __Infer<typeof LeaseGraderUploadUrl>;

export const LeaseUploadWebhookAttachment = __t.object("LeaseUploadWebhookAttachment", {
  gcsUri: __t.string(),
  originalFileName: __t.string(),
});
export type LeaseUploadWebhookAttachment = __Infer<typeof LeaseUploadWebhookAttachment>;

// The tagged union or sum type for the algebraic type `LengthUnit`.
export const LengthUnit = __t.enum("LengthUnit", {
  Characters: __t.unit(),
  Words: __t.unit(),
});
export type LengthUnit = __Infer<typeof LengthUnit>;

export const LinkExternalAccountOperationsV1 = __t.object("LinkExternalAccountOperationsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  accountId: __t.string(),
  status: __t.string(),
  params: __t.string(),
  error: __t.option(__t.string()),
});
export type LinkExternalAccountOperationsV1 = __Infer<typeof LinkExternalAccountOperationsV1>;

export const MergeCreateLinkTokenResponse = __t.object("MergeCreateLinkTokenResponse", {
  linkToken: __t.string(),
});
export type MergeCreateLinkTokenResponse = __Infer<typeof MergeCreateLinkTokenResponse>;

export const MergeItemForUserRow = __t.object("MergeItemForUserRow", {
  tychoId: __t.uuid(),
  integration: __t.string(),
  createdAt: __t.timestamp(),
});
export type MergeItemForUserRow = __Infer<typeof MergeItemForUserRow>;

export const MergeItemsToUnderwritableEntitiesV1 = __t.object("MergeItemsToUnderwritableEntitiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  mergeItem: __t.uuid(),
  underwritableEntity: __t.uuid(),
});
export type MergeItemsToUnderwritableEntitiesV1 = __Infer<typeof MergeItemsToUnderwritableEntitiesV1>;

export const MergeItemsV1 = __t.object("MergeItemsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  tychoId: __t.uuid(),
  mergeAccountToken: __t.string(),
  integration: __t.string(),
  mergeLinkedAccountId: __t.option(__t.string()),
});
export type MergeItemsV1 = __Infer<typeof MergeItemsV1>;

export const MigrationsV1 = __t.object("MigrationsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  name: __t.string(),
  appliedAt: __t.timestamp(),
});
export type MigrationsV1 = __Infer<typeof MigrationsV1>;

export const MultipleChoiceAnswer = __t.object("MultipleChoiceAnswer", {
  value: __t.array(__t.string()),
  note: __t.option(__t.string()),
});
export type MultipleChoiceAnswer = __Infer<typeof MultipleChoiceAnswer>;

export const MultipleChoiceOption = __t.object("MultipleChoiceOption", {
  id: __t.string(),
  label: __t.string(),
  position: __t.string(),
});
export type MultipleChoiceOption = __Infer<typeof MultipleChoiceOption>;

export const MultipleChoiceQuestionWithAnswer = __t.object("MultipleChoiceQuestionWithAnswer", {
  id: __t.string(),
  title: __t.string(),
  subtitle: __t.option(__t.string()),
  get details() {
    return __t.option(QuestionDetails);
  },
  get multipleChoiceType() {
    return MultipleChoiceType;
  },
  get options() {
    return __t.array(MultipleChoiceOption);
  },
  get answer() {
    return __t.option(MultipleChoiceAnswer);
  },
});
export type MultipleChoiceQuestionWithAnswer = __Infer<typeof MultipleChoiceQuestionWithAnswer>;

// The tagged union or sum type for the algebraic type `MultipleChoiceType`.
export const MultipleChoiceType = __t.enum("MultipleChoiceType", {
  Single: __t.unit(),
  Multi: __t.unit(),
});
export type MultipleChoiceType = __Infer<typeof MultipleChoiceType>;

export const MyBusinessCardInterestRow = __t.object("MyBusinessCardInterestRow", {
  cardId: __t.uuid(),
  interestDollarAmount: __t.i64(),
  firstName: __t.option(__t.string()),
  lastName: __t.option(__t.string()),
  supportiveMessage: __t.option(__t.string()),
  consentToDisplay: __t.bool(),
});
export type MyBusinessCardInterestRow = __Infer<typeof MyBusinessCardInterestRow>;

export const MyBusinessCardInterests = __t.object("MyBusinessCardInterests", {});
export type MyBusinessCardInterests = __Infer<typeof MyBusinessCardInterests>;

export const MyFundingSources = __t.object("MyFundingSources", {});
export type MyFundingSources = __Infer<typeof MyFundingSources>;

export const MyNominationInterestRow = __t.object("MyNominationInterestRow", {
  nominatedBusinessId: __t.string(),
  intendedInvestmentDollars: __t.u32(),
  reason: __t.option(__t.string()),
  firstName: __t.option(__t.string()),
  lastName: __t.option(__t.string()),
  consentToDisplay: __t.option(__t.bool()),
});
export type MyNominationInterestRow = __Infer<typeof MyNominationInterestRow>;

export const MyNominationInterests = __t.object("MyNominationInterests", {});
export type MyNominationInterests = __Infer<typeof MyNominationInterests>;

export const MyTransactAccountId = __t.object("MyTransactAccountId", {});
export type MyTransactAccountId = __Infer<typeof MyTransactAccountId>;

export const MyTransactAccountRow = __t.object("MyTransactAccountRow", {
  accountId: __t.string(),
});
export type MyTransactAccountRow = __Infer<typeof MyTransactAccountRow>;

export const NeedsMoreInfoAnswer = __t.object("NeedsMoreInfoAnswer", {
  value: __t.bool(),
  note: __t.option(__t.string()),
});
export type NeedsMoreInfoAnswer = __Infer<typeof NeedsMoreInfoAnswer>;

export const NeedsMoreInfoQuestionWithAnswer = __t.object("NeedsMoreInfoQuestionWithAnswer", {
  id: __t.string(),
  title: __t.string(),
  subtitle: __t.option(__t.string()),
  get details() {
    return __t.option(QuestionDetails);
  },
  get infoType() {
    return AdditionalInfoType;
  },
  get answer() {
    return __t.option(NeedsMoreInfoAnswer);
  },
});
export type NeedsMoreInfoQuestionWithAnswer = __Infer<typeof NeedsMoreInfoQuestionWithAnswer>;

export const NominatedBusinessesV1 = __t.object("NominatedBusinessesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  googlePlaceId: __t.string(),
  name: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  nominatedByClerkUserIdV1: __t.option(__t.string()),
  totalInterested: __t.u32(),
});
export type NominatedBusinessesV1 = __Infer<typeof NominatedBusinessesV1>;

export const NominatedBusinessesV2 = __t.object("NominatedBusinessesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  googlePlaceId: __t.string(),
  name: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  nominatedByClerkUserIdV1: __t.option(__t.string()),
  totalInterested: __t.u32(),
  get canonicalAddress() {
    return __t.option(CanonicalAddress);
  },
});
export type NominatedBusinessesV2 = __Infer<typeof NominatedBusinessesV2>;

export const NominatedBusinessesV3 = __t.object("NominatedBusinessesV3", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  googlePlaceId: __t.string(),
  name: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  nominatedByClerkUserIdV1: __t.option(__t.string()),
  totalInterested: __t.u32(),
  get canonicalAddress() {
    return __t.option(CanonicalAddress);
  },
  browsable: __t.bool(),
});
export type NominatedBusinessesV3 = __Infer<typeof NominatedBusinessesV3>;

export const NominatedBusinessesV4 = __t.object("NominatedBusinessesV4", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  googlePlaceId: __t.string(),
  name: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  nominatedByClerkUserIdV1: __t.option(__t.string()),
  totalInterested: __t.u32(),
  get canonicalAddress() {
    return __t.option(CanonicalAddress);
  },
  browsable: __t.bool(),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
});
export type NominatedBusinessesV4 = __Infer<typeof NominatedBusinessesV4>;

export const NominationClaimsV1 = __t.object("NominationClaimsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  nominatedBusinessV1: __t.string(),
  claimerClerkUserIdV1: __t.string(),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorSecondary: __t.option(__t.string()),
  colorTertiary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
});
export type NominationClaimsV1 = __Infer<typeof NominationClaimsV1>;

export const NominationHeroUploadUrl = __t.object("NominationHeroUploadUrl", {
  uploadUrl: __t.string(),
  objectPath: __t.string(),
  contentType: __t.string(),
  contentLengthRange: __t.string(),
});
export type NominationHeroUploadUrl = __Infer<typeof NominationHeroUploadUrl>;

export const NominationInterestV1 = __t.object("NominationInterestV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  nominatedBusinessV1: __t.string(),
  interestedClerkUserIdV1: __t.string(),
  intendedInvestmentDollars: __t.u32(),
  reason: __t.option(__t.string()),
});
export type NominationInterestV1 = __Infer<typeof NominationInterestV1>;

export const NominationInterestV2 = __t.object("NominationInterestV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  nominatedBusinessV1: __t.string(),
  interestedClerkUserIdV1: __t.string(),
  intendedInvestmentDollars: __t.u32(),
  reason: __t.option(__t.string()),
  email: __t.string(),
  firstName: __t.option(__t.string()),
  lastName: __t.option(__t.string()),
});
export type NominationInterestV2 = __Infer<typeof NominationInterestV2>;

export const NominationInterestV3 = __t.object("NominationInterestV3", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  nominatedBusinessV1: __t.string(),
  interestedClerkUserIdV1: __t.string(),
  intendedInvestmentDollars: __t.u32(),
  reason: __t.option(__t.string()),
  email: __t.string(),
  firstName: __t.option(__t.string()),
  lastName: __t.option(__t.string()),
  consentToDisplay: __t.option(__t.bool()),
});
export type NominationInterestV3 = __Infer<typeof NominationInterestV3>;

export const NumberAnswer = __t.object("NumberAnswer", {
  value: __t.f64(),
  note: __t.option(__t.string()),
});
export type NumberAnswer = __Infer<typeof NumberAnswer>;

export const NumberQuestionWithAnswer = __t.object("NumberQuestionWithAnswer", {
  id: __t.string(),
  title: __t.string(),
  subtitle: __t.option(__t.string()),
  get details() {
    return __t.option(QuestionDetails);
  },
  get units() {
    return QuestionNumberUnit;
  },
  min: __t.f64(),
  max: __t.f64(),
  step: __t.option(__t.f64()),
  defaultValue: __t.option(__t.f64()),
  get answer() {
    return __t.option(NumberAnswer);
  },
});
export type NumberQuestionWithAnswer = __Infer<typeof NumberQuestionWithAnswer>;

// The tagged union or sum type for the algebraic type `OfferingStatusV1`.
export const OfferingStatusV1 = __t.enum("OfferingStatusV1", {
  Draft: __t.unit(),
  Open: __t.unit(),
  Closed: __t.unit(),
});
export type OfferingStatusV1 = __Infer<typeof OfferingStatusV1>;

export const OfferingsV1 = __t.object("OfferingsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  ttwPage: __t.uuid(),
  transactOfferingId: __t.option(__t.string()),
  name: __t.string(),
  get status() {
    return OfferingStatusV1;
  },
  targetAmountCents: __t.i64(),
  maxAmountCents: __t.i64(),
  minCheckSizeCents: __t.i64(),
  startDateMs: __t.i64(),
  endDateMs: __t.i64(),
  maxPerInvestorCents: __t.option(__t.i64()),
});
export type OfferingsV1 = __Infer<typeof OfferingsV1>;

// The tagged union or sum type for the algebraic type `OpLocationsJobStatusV1`.
export const OpLocationsJobStatusV1 = __t.enum("OpLocationsJobStatusV1", {
  Pending: __t.unit(),
  Complete: __t.unit(),
  NoResults: __t.unit(),
  Failed: __t.unit(),
  TimedOut: __t.unit(),
});
export type OpLocationsJobStatusV1 = __Infer<typeof OpLocationsJobStatusV1>;

export const OperatingLocations = __t.object("OperatingLocations", {
  discoveredCount: __t.u32(),
  confirmedCount: __t.u32(),
  get jobStatus() {
    return __t.option(OpLocationsJobStatusV1);
  },
});
export type OperatingLocations = __Infer<typeof OperatingLocations>;

export const OperatingLocationsWebhookScheduleV1 = __t.object("OperatingLocationsWebhookScheduleV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  brand: __t.uuid(),
});
export type OperatingLocationsWebhookScheduleV1 = __Infer<typeof OperatingLocationsWebhookScheduleV1>;

export const OperatingPropertiesJobStatusForUser = __t.object("OperatingPropertiesJobStatusForUser", {});
export type OperatingPropertiesJobStatusForUser = __Infer<typeof OperatingPropertiesJobStatusForUser>;

export const OperatingPropertiesJobStatusForUserRow = __t.object("OperatingPropertiesJobStatusForUserRow", {
  brand: __t.uuid(),
  get jobStatus() {
    return __t.option(OpLocationsJobStatusV1);
  },
});
export type OperatingPropertiesJobStatusForUserRow = __Infer<typeof OperatingPropertiesJobStatusForUserRow>;

export const OperatingPropertiesV1 = __t.object("OperatingPropertiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  brandV1: __t.u64(),
  get canonicalAddress() {
    return CanonicalAddress;
  },
  googlePlaceId: __t.string(),
  googlePlacePhotoName: __t.option(__t.string()),
  confirmed: __t.bool(),
});
export type OperatingPropertiesV1 = __Infer<typeof OperatingPropertiesV1>;

export const OperatingPropertiesV2 = __t.object("OperatingPropertiesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  brand: __t.uuid(),
  get canonicalAddress() {
    return CanonicalAddress;
  },
  googlePlaceId: __t.string(),
  googlePlacePhotoName: __t.option(__t.string()),
  confirmed: __t.bool(),
});
export type OperatingPropertiesV2 = __Infer<typeof OperatingPropertiesV2>;

export const OperatingPropertyForUserRow = __t.object("OperatingPropertyForUserRow", {
  id: __t.uuid(),
  brand: __t.uuid(),
  googlePlaceId: __t.string(),
  googlePlacePhotoName: __t.option(__t.string()),
  get canonicalAddress() {
    return CanonicalAddress;
  },
  confirmed: __t.bool(),
});
export type OperatingPropertyForUserRow = __Infer<typeof OperatingPropertyForUserRow>;

export const OrderReconcileCronV1 = __t.object("OrderReconcileCronV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type OrderReconcileCronV1 = __Infer<typeof OrderReconcileCronV1>;

// The tagged union or sum type for the algebraic type `OrderStatusV1`.
export const OrderStatusV1 = __t.enum("OrderStatusV1", {
  Created: __t.unit(),
  Pending: __t.unit(),
  Submitted: __t.unit(),
  Funded: __t.unit(),
  ExpiredSubmitted: __t.unit(),
  Closed: __t.unit(),
  Refunding: __t.unit(),
  Canceled: __t.unit(),
  TransactionError: __t.unit(),
  RefundError: __t.unit(),
});
export type OrderStatusV1 = __Infer<typeof OrderStatusV1>;

export const OrdersV1 = __t.object("OrdersV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  offering: __t.uuid(),
  investor: __t.string(),
  amountCents: __t.i64(),
  get status() {
    return OrderStatusV1;
  },
  transactTradeId: __t.option(__t.string()),
  transactRefNum: __t.option(__t.string()),
  linkedAccountId: __t.option(__t.string()),
  transactionInitiatedAt: __t.option(__t.timestamp()),
  lastSyncedAt: __t.option(__t.timestamp()),
  previousOrder: __t.option(__t.uuid()),
  errorMessage: __t.option(__t.string()),
});
export type OrdersV1 = __Infer<typeof OrdersV1>;

// The tagged union or sum type for the algebraic type `OrientationStatus`.
export const OrientationStatus = __t.enum("OrientationStatus", {
  Completed: __t.unit(),
  InProgress: __t.unit(),
  Skipped: __t.unit(),
});
export type OrientationStatus = __Infer<typeof OrientationStatus>;

export const PendingInviteRow = __t.object("PendingInviteRow", {
  inviteId: __t.uuid(),
  brand: __t.uuid(),
  brandName: __t.string(),
  brandHeroCdnPath: __t.option(__t.string()),
  invitedByName: __t.string(),
});
export type PendingInviteRow = __Infer<typeof PendingInviteRow>;

export const PendingInvitesForUser = __t.object("PendingInvitesForUser", {});
export type PendingInvitesForUser = __Infer<typeof PendingInvitesForUser>;

export const PlaidCreateLinkTokenResponse = __t.object("PlaidCreateLinkTokenResponse", {
  linkToken: __t.string(),
  expiration: __t.string(),
  requestId: __t.string(),
  hostedLinkUrl: __t.option(__t.string()),
  userId: __t.option(__t.string()),
});
export type PlaidCreateLinkTokenResponse = __Infer<typeof PlaidCreateLinkTokenResponse>;

export const PlaidItemDataSync = __t.object("PlaidItemDataSync", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  plaidTychoId: __t.u64(),
  underwritableEntityV1: __t.u64(),
});
export type PlaidItemDataSync = __Infer<typeof PlaidItemDataSync>;

export const PlaidItemForUserRow = __t.object("PlaidItemForUserRow", {
  tychoId: __t.uuid(),
  institutionName: __t.string(),
  createdAt: __t.timestamp(),
});
export type PlaidItemForUserRow = __Infer<typeof PlaidItemForUserRow>;

export const PlaidItemsToUnderwritableEntitiesV1 = __t.object("PlaidItemsToUnderwritableEntitiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  plaidItemV1: __t.u64(),
  underwritableEntityV1: __t.u64(),
});
export type PlaidItemsToUnderwritableEntitiesV1 = __Infer<typeof PlaidItemsToUnderwritableEntitiesV1>;

export const PlaidItemsToUnderwritableEntitiesV2 = __t.object("PlaidItemsToUnderwritableEntitiesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  plaidItem: __t.uuid(),
  underwritableEntity: __t.uuid(),
});
export type PlaidItemsToUnderwritableEntitiesV2 = __Infer<typeof PlaidItemsToUnderwritableEntitiesV2>;

export const PlaidItemsV1 = __t.object("PlaidItemsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  tychoId: __t.u64(),
  plaidItemId: __t.string(),
  plaidAccessToken: __t.string(),
  fragileInstitutionName: __t.string(),
  get jobStatus() {
    return AthenaAsyncStatusFieldsJobStatus;
  },
  error: __t.option(__t.string()),
  get result() {
    return __t.option(AthenaBankingConnectionResponse);
  },
});
export type PlaidItemsV1 = __Infer<typeof PlaidItemsV1>;

export const PlaidItemsV2 = __t.object("PlaidItemsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  tychoId: __t.uuid(),
  plaidItemId: __t.string(),
  plaidAccessToken: __t.string(),
  fragileInstitutionName: __t.string(),
  get jobStatus() {
    return AthenaAsyncStatusFieldsJobStatus;
  },
  error: __t.option(__t.string()),
  get result() {
    return __t.option(AthenaBankingConnectionResponse);
  },
});
export type PlaidItemsV2 = __Infer<typeof PlaidItemsV2>;

export const PlaidScheduledItemsV2 = __t.object("PlaidScheduledItemsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  plaidTychoId: __t.uuid(),
  underwritableEntity: __t.uuid(),
});
export type PlaidScheduledItemsV2 = __Infer<typeof PlaidScheduledItemsV2>;

export const PosConnection = __t.object("PosConnection", {
  id: __t.string(),
  platform: __t.string(),
});
export type PosConnection = __Infer<typeof PosConnection>;

export const PosItemDataSync = __t.object("PosItemDataSync", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  posTychoId: __t.u64(),
  underwritableEntityV1: __t.u64(),
});
export type PosItemDataSync = __Infer<typeof PosItemDataSync>;

export const PosItemForUserRow = __t.object("PosItemForUserRow", {
  tychoId: __t.uuid(),
  platform: __t.string(),
  createdAt: __t.timestamp(),
});
export type PosItemForUserRow = __Infer<typeof PosItemForUserRow>;

export const PosItemsToUnderwritableEntitiesV1 = __t.object("PosItemsToUnderwritableEntitiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  posItemV1: __t.u64(),
  underwritableEntityV1: __t.u64(),
});
export type PosItemsToUnderwritableEntitiesV1 = __Infer<typeof PosItemsToUnderwritableEntitiesV1>;

export const PosItemsToUnderwritableEntitiesV2 = __t.object("PosItemsToUnderwritableEntitiesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  posItem: __t.uuid(),
  underwritableEntity: __t.uuid(),
});
export type PosItemsToUnderwritableEntitiesV2 = __Infer<typeof PosItemsToUnderwritableEntitiesV2>;

export const PosItemsV1 = __t.object("PosItemsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  tychoId: __t.u64(),
  rutterConnectionId: __t.string(),
  rutterAccessToken: __t.string(),
  platform: __t.string(),
  get jobStatus() {
    return AthenaAsyncStatusFieldsJobStatus;
  },
  error: __t.option(__t.string()),
});
export type PosItemsV1 = __Infer<typeof PosItemsV1>;

export const PosItemsV2 = __t.object("PosItemsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  tychoId: __t.uuid(),
  rutterConnectionId: __t.string(),
  rutterAccessToken: __t.string(),
  platform: __t.string(),
  get jobStatus() {
    return AthenaAsyncStatusFieldsJobStatus;
  },
  error: __t.option(__t.string()),
});
export type PosItemsV2 = __Infer<typeof PosItemsV2>;

export const PosScheduledItemsV2 = __t.object("PosScheduledItemsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  posTychoId: __t.uuid(),
  underwritableEntity: __t.uuid(),
});
export type PosScheduledItemsV2 = __Infer<typeof PosScheduledItemsV2>;

export const PromoteTtwPageResult = __t.object("PromoteTtwPageResult", {
  offeringId: __t.string(),
  transactOfferingId: __t.string(),
});
export type PromoteTtwPageResult = __Infer<typeof PromoteTtwPageResult>;

export const Property = __t.object("Property", {
  id: __t.uuid(),
  get address() {
    return CanonicalAddress;
  },
  googlePlaceId: __t.option(__t.string()),
  googlePlacePhotoName: __t.option(__t.string()),
  imageUrl: __t.option(__t.string()),
  get comps() {
    return __t.array(Comp);
  },
  approvedCompIds: __t.array(__t.string()),
  selectedCompIds: __t.array(__t.string()),
  priceEstimate: __t.option(__t.f64()),
  get userThinksPriceEstimateIs() {
    return __t.option(UserPriceJudgement);
  },
  orderedAppraisal: __t.option(__t.bool()),
  invitedLandlord: __t.option(__t.bool()),
  get userMaxPrice() {
    return __t.option(UserMaxPrice);
  },
  get compsJobStatus() {
    return __t.option(TargetablePropertyCompsJobStatusV1);
  },
  compsJobErrorKind: __t.option(__t.string()),
  get userIntendedContribution() {
    return __t.option(UserIntendedContribution);
  },
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
});
export type Property = __Infer<typeof Property>;

export const PublicOfferingRow = __t.object("PublicOfferingRow", {
  isOpen: __t.bool(),
  id: __t.option(__t.uuid()),
  name: __t.string(),
  minCheckSizeCents: __t.i64(),
  maxPerInvestorCents: __t.option(__t.i64()),
  startDateMs: __t.i64(),
  endDateMs: __t.i64(),
  alreadyCommittedCents: __t.i64(),
  remainingAllowanceCents: __t.option(__t.i64()),
  hasCommittedOrder: __t.bool(),
  targetAmountCents: __t.i64(),
  raisedCents: __t.i64(),
  investorCount: __t.u32(),
});
export type PublicOfferingRow = __Infer<typeof PublicOfferingRow>;

// The tagged union or sum type for the algebraic type `QuestionAnswer`.
export const QuestionAnswer = __t.enum("QuestionAnswer", {
  get YesNo() {
    return YesNoAnswer;
  },
  get Number() {
    return NumberAnswer;
  },
  get MultipleChoice() {
    return MultipleChoiceAnswer;
  },
  get Freeform() {
    return FreeformAnswer;
  },
  get NeedsMoreInfo() {
    return NeedsMoreInfoAnswer;
  },
});
export type QuestionAnswer = __Infer<typeof QuestionAnswer>;

export const QuestionDetails = __t.object("QuestionDetails", {
  title: __t.string(),
  subtitle: __t.option(__t.string()),
  get chart() {
    return __t.option(Chart);
  },
});
export type QuestionDetails = __Infer<typeof QuestionDetails>;

// The tagged union or sum type for the algebraic type `QuestionNumberUnit`.
export const QuestionNumberUnit = __t.enum("QuestionNumberUnit", {
  Dollars: __t.unit(),
  DollarsPerMonth: __t.unit(),
  People: __t.unit(),
  SquareFeet: __t.unit(),
});
export type QuestionNumberUnit = __Infer<typeof QuestionNumberUnit>;

// The tagged union or sum type for the algebraic type `QuestionWithAnswer`.
export const QuestionWithAnswer = __t.enum("QuestionWithAnswer", {
  get YesNo() {
    return YesnoQuestionWithAnswer;
  },
  get Number() {
    return NumberQuestionWithAnswer;
  },
  get MultipleChoice() {
    return MultipleChoiceQuestionWithAnswer;
  },
  get Freeform() {
    return FreeformQuestionWithAnswer;
  },
  get NeedsMoreInfo() {
    return NeedsMoreInfoQuestionWithAnswer;
  },
});
export type QuestionWithAnswer = __Infer<typeof QuestionWithAnswer>;

export const RemoveInterestInBusinessCardResult = __t.object("RemoveInterestInBusinessCardResult", {
  deleted: __t.bool(),
});
export type RemoveInterestInBusinessCardResult = __Infer<typeof RemoveInterestInBusinessCardResult>;

export const ResolveLeaseUploadCode = __t.object("ResolveLeaseUploadCode", {
  ok: __t.bool(),
  underwritableEntity: __t.option(__t.uuid()),
  reason: __t.option(__t.string()),
});
export type ResolveLeaseUploadCode = __Infer<typeof ResolveLeaseUploadCode>;

export const SavedComposerPageRow = __t.object("SavedComposerPageRow", {
  cardId: __t.uuid(),
});
export type SavedComposerPageRow = __Infer<typeof SavedComposerPageRow>;

export const SavedTtwPageRow = __t.object("SavedTtwPageRow", {
  cardId: __t.uuid(),
  isAccessProtected: __t.bool(),
});
export type SavedTtwPageRow = __Infer<typeof SavedTtwPageRow>;

export const SecretsV1 = __t.object("SecretsV1", {
  key: __t.string(),
  value: __t.string(),
  updatedBy: __t.string(),
});
export type SecretsV1 = __Infer<typeof SecretsV1>;

export const SecretsView = __t.object("SecretsView", {});
export type SecretsView = __Infer<typeof SecretsView>;

export const ShareBusinessCardContextRow = __t.object("ShareBusinessCardContextRow", {
  underwritableEntity: __t.uuid(),
  brandV1: __t.uuid(),
  brandFriendlyName: __t.option(__t.string()),
  brandHeroCdnPath: __t.option(__t.string()),
  brandColorPrimary: __t.option(__t.string()),
  brandBusinessCategory: __t.option(__t.string()),
  brandBusinessType: __t.option(__t.string()),
  get brandBusinessAddress() {
    return __t.option(CanonicalAddress);
  },
  get targetedPropertyAddress() {
    return __t.option(CanonicalAddress);
  },
  targetedPropertyPhotoName: __t.option(__t.string()),
});
export type ShareBusinessCardContextRow = __Infer<typeof ShareBusinessCardContextRow>;

export const ShareBusinessCardContexts = __t.object("ShareBusinessCardContexts", {});
export type ShareBusinessCardContexts = __Infer<typeof ShareBusinessCardContexts>;

export const ShareableBusinessCardExpressionsOfInterestV1 = __t.object("ShareableBusinessCardExpressionsOfInterestV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  clerkUserIdV1: __t.string(),
  shareableBusinessCardV1: __t.u64(),
  interestDollarAmount: __t.i64(),
  denormalizedUserAndInterestCard: __t.string(),
});
export type ShareableBusinessCardExpressionsOfInterestV1 = __Infer<typeof ShareableBusinessCardExpressionsOfInterestV1>;

export const ShareableBusinessCardExpressionsOfInterestV2 = __t.object("ShareableBusinessCardExpressionsOfInterestV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  clerkUserIdV1: __t.string(),
  shareableBusinessCardV2: __t.uuid(),
  interestDollarAmount: __t.i64(),
  denormalizedUserAndInterestCard: __t.string(),
});
export type ShareableBusinessCardExpressionsOfInterestV2 = __Infer<typeof ShareableBusinessCardExpressionsOfInterestV2>;

export const ShareableBusinessCardExpressionsOfInterestV3 = __t.object("ShareableBusinessCardExpressionsOfInterestV3", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  clerkUserIdV1: __t.string(),
  shareableBusinessCardV2: __t.uuid(),
  interestDollarAmount: __t.i64(),
  supportiveMessage: __t.option(__t.string()),
  consentToDisplay: __t.bool(),
  denormalizedUserAndInterestCard: __t.string(),
});
export type ShareableBusinessCardExpressionsOfInterestV3 = __Infer<typeof ShareableBusinessCardExpressionsOfInterestV3>;

export const ShareableBusinessCardExpressionsOfInterestV4 = __t.object("ShareableBusinessCardExpressionsOfInterestV4", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  clerkUserIdV1: __t.string(),
  shareableBusinessCardV2: __t.uuid(),
  interestDollarAmount: __t.i64(),
  supportiveMessage: __t.option(__t.string()),
  consentToDisplay: __t.bool(),
  firstName: __t.option(__t.string()),
  lastName: __t.option(__t.string()),
  denormalizedUserAndInterestCard: __t.string(),
});
export type ShareableBusinessCardExpressionsOfInterestV4 = __Infer<typeof ShareableBusinessCardExpressionsOfInterestV4>;

export const ShareableBusinessCardExpressionsOfInterestV5 = __t.object("ShareableBusinessCardExpressionsOfInterestV5", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  clerkUserIdV1: __t.string(),
  shareableBusinessCardV2: __t.uuid(),
  interestDollarAmount: __t.i64(),
  supportiveMessage: __t.option(__t.string()),
  consentToDisplay: __t.bool(),
  firstName: __t.option(__t.string()),
  lastName: __t.option(__t.string()),
  email: __t.string(),
  denormalizedUserAndInterestCard: __t.string(),
});
export type ShareableBusinessCardExpressionsOfInterestV5 = __Infer<typeof ShareableBusinessCardExpressionsOfInterestV5>;

export const ShareableBusinessCardRecipientRow = __t.object("ShareableBusinessCardRecipientRow", {
  brandFriendlyName: __t.option(__t.string()),
  brandHeroCdnPath: __t.option(__t.string()),
  brandColorPrimary: __t.option(__t.string()),
  brandBusinessType: __t.option(__t.string()),
  get brandBusinessAddress() {
    return __t.option(CanonicalAddress);
  },
  get targetedPropertyAddress() {
    return __t.option(CanonicalAddress);
  },
  expressionsOfInterestCount: __t.u32(),
  userInterestDollarAmount: __t.option(__t.i64()),
  userSupportiveMessage: __t.option(__t.string()),
  userConsentToDisplay: __t.option(__t.bool()),
});
export type ShareableBusinessCardRecipientRow = __Infer<typeof ShareableBusinessCardRecipientRow>;

export const ShareableBusinessCardsV1 = __t.object("ShareableBusinessCardsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  underwritableEntityV1: __t.u64(),
  accessCode: __t.option(__t.string()),
  isActive: __t.bool(),
});
export type ShareableBusinessCardsV1 = __Infer<typeof ShareableBusinessCardsV1>;

export const ShareableBusinessCardsV2 = __t.object("ShareableBusinessCardsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  underwritableEntityV1: __t.u64(),
  accessCode: __t.option(__t.string()),
  isActive: __t.bool(),
  browsable: __t.bool(),
});
export type ShareableBusinessCardsV2 = __Infer<typeof ShareableBusinessCardsV2>;

export const ShareableBusinessCardsV3 = __t.object("ShareableBusinessCardsV3", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  underwritableEntity: __t.uuid(),
  accessCode: __t.option(__t.string()),
  isActive: __t.bool(),
  browsable: __t.bool(),
});
export type ShareableBusinessCardsV3 = __Infer<typeof ShareableBusinessCardsV3>;

export const SmbDashboardOrientationV1 = __t.object("SmbDashboardOrientationV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  clerkUserIdV1: __t.string(),
  brandIdV1: __t.u64(),
  compositeId: __t.string(),
  get status() {
    return OrientationStatus;
  },
});
export type SmbDashboardOrientationV1 = __Infer<typeof SmbDashboardOrientationV1>;

export const SmbDashboardOrientationV2 = __t.object("SmbDashboardOrientationV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  clerkUserId: __t.string(),
  brandId: __t.uuid(),
  compositeId: __t.string(),
  get status() {
    return OrientationStatus;
  },
});
export type SmbDashboardOrientationV2 = __Infer<typeof SmbDashboardOrientationV2>;

export const SmbOnboardedNotificationScheduleV1 = __t.object("SmbOnboardedNotificationScheduleV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  brand: __t.uuid(),
});
export type SmbOnboardedNotificationScheduleV1 = __Infer<typeof SmbOnboardedNotificationScheduleV1>;

export const SmbOnboarding = __t.object("SmbOnboarding", {});
export type SmbOnboarding = __Infer<typeof SmbOnboarding>;

// The tagged union or sum type for the algebraic type `SmbOnboardingFlowKind`.
export const SmbOnboardingFlowKind = __t.enum("SmbOnboardingFlowKind", {
  Organic: __t.unit(),
  Invited: __t.unit(),
});
export type SmbOnboardingFlowKind = __Infer<typeof SmbOnboardingFlowKind>;

export const SmbOnboardingRow = __t.object("SmbOnboardingRow", {
  googlePlaceId: __t.option(__t.string()),
  googlePlacePhotoName: __t.option(__t.string()),
  name: __t.option(__t.string()),
  get businessAddress() {
    return __t.option(CanonicalAddress);
  },
  businessCategory: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  websiteUrl: __t.option(__t.string()),
  nominatedBusinessV1: __t.option(__t.string()),
  claimRequestId: __t.option(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorSecondary: __t.option(__t.string()),
  colorTertiary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  browsable: __t.bool(),
  businessTags: __t.array(__t.string()),
  get flowKind() {
    return SmbOnboardingFlowKind;
  },
  sourceInvitedBrandDraft: __t.option(__t.uuid()),
  get invitedStep() {
    return __t.option(InvitedOnboardingStep);
  },
});
export type SmbOnboardingRow = __Infer<typeof SmbOnboardingRow>;

export const SmbOnboardingV1 = __t.object("SmbOnboardingV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  ownerClerkUserIdV1: __t.string(),
  googlePlaceId: __t.option(__t.string()),
  googlePlacePhotoName: __t.option(__t.string()),
  name: __t.option(__t.string()),
  get businessAddress() {
    return __t.option(CanonicalAddress);
  },
  businessCategory: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  websiteUrl: __t.option(__t.string()),
  nominatedBusinessV1: __t.option(__t.string()),
  claimRequestId: __t.option(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorSecondary: __t.option(__t.string()),
  colorTertiary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  businessTags: __t.array(__t.string()),
});
export type SmbOnboardingV1 = __Infer<typeof SmbOnboardingV1>;

export const SmbOnboardingV2 = __t.object("SmbOnboardingV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  ownerClerkUserIdV1: __t.string(),
  googlePlaceId: __t.option(__t.string()),
  googlePlacePhotoName: __t.option(__t.string()),
  name: __t.option(__t.string()),
  get businessAddress() {
    return __t.option(CanonicalAddress);
  },
  businessCategory: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  websiteUrl: __t.option(__t.string()),
  nominatedBusinessV1: __t.option(__t.string()),
  claimRequestId: __t.option(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorSecondary: __t.option(__t.string()),
  colorTertiary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  browsable: __t.bool(),
  businessTags: __t.array(__t.string()),
});
export type SmbOnboardingV2 = __Infer<typeof SmbOnboardingV2>;

export const SmbOnboardingV3 = __t.object("SmbOnboardingV3", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  ownerClerkUserIdV1: __t.string(),
  googlePlaceId: __t.option(__t.string()),
  googlePlacePhotoName: __t.option(__t.string()),
  name: __t.option(__t.string()),
  get businessAddress() {
    return __t.option(CanonicalAddress);
  },
  businessCategory: __t.option(__t.string()),
  businessType: __t.option(__t.string()),
  websiteUrl: __t.option(__t.string()),
  nominatedBusinessV1: __t.option(__t.string()),
  claimRequestId: __t.option(__t.string()),
  heroCdnPath: __t.option(__t.string()),
  colorPrimary: __t.option(__t.string()),
  colorSecondary: __t.option(__t.string()),
  colorTertiary: __t.option(__t.string()),
  colorText: __t.option(__t.string()),
  browsable: __t.bool(),
  businessTags: __t.array(__t.string()),
  get flowKind() {
    return SmbOnboardingFlowKind;
  },
  sourceInvitedBrandDraft: __t.option(__t.uuid()),
  get invitedStep() {
    return __t.option(InvitedOnboardingStep);
  },
});
export type SmbOnboardingV3 = __Infer<typeof SmbOnboardingV3>;

export const SmbSuperView = __t.object("SmbSuperView", {});
export type SmbSuperView = __Infer<typeof SmbSuperView>;

export const SmbSuperViewConnection = __t.object("SmbSuperViewConnection", {
  kind: __t.string(),
  id: __t.uuid(),
  displayName: __t.string(),
});
export type SmbSuperViewConnection = __Infer<typeof SmbSuperViewConnection>;

export const SmbSuperViewElement = __t.object("SmbSuperViewElement", {
  underwritableEntityId: __t.uuid(),
  get underwritableEntity() {
    return UnderwritableEntitiesV4;
  },
  get brand() {
    return BrandsV4;
  },
  get businessCards() {
    return __t.array(BusinessCardWithInterests);
  },
  currentPurchasingPower: __t.option(__t.f64()),
  get targetedProperties() {
    return __t.array(TargetedPropertySuperView);
  },
  hasFinancialConnections: __t.bool(),
  get connections() {
    return __t.array(SmbSuperViewConnection);
  },
  get appraisals() {
    return __t.array(AppraisalsV2);
  },
  get userUwAcknowledgments() {
    return __t.array(UserUwAcknowledgmentsV2);
  },
});
export type SmbSuperViewElement = __Infer<typeof SmbSuperViewElement>;

export const SubmitExternalFundMoveArgs = __t.object("SubmitExternalFundMoveArgs", {
  accountId: __t.string(),
  tradeId: __t.string(),
  offeringId: __t.string(),
  amount: __t.string(),
  nickName: __t.string(),
  description: __t.string(),
  checkNumber: __t.string(),
});
export type SubmitExternalFundMoveArgs = __Infer<typeof SubmitExternalFundMoveArgs>;

export const SubmitOrderResult = __t.object("SubmitOrderResult", {
  orderId: __t.string(),
  transactRefNum: __t.option(__t.string()),
});
export type SubmitOrderResult = __Infer<typeof SubmitOrderResult>;

export const TargetablePropertiesV1 = __t.object("TargetablePropertiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  get canonicalAddress() {
    return CanonicalAddress;
  },
  googlePlaceId: __t.string(),
  googlePlacePhotoName: __t.option(__t.string()),
});
export type TargetablePropertiesV1 = __Infer<typeof TargetablePropertiesV1>;

export const TargetablePropertiesV2 = __t.object("TargetablePropertiesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  get canonicalAddress() {
    return CanonicalAddress;
  },
  googlePlaceId: __t.string(),
  googlePlacePhotoName: __t.option(__t.string()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
});
export type TargetablePropertiesV2 = __Infer<typeof TargetablePropertiesV2>;

export const TargetablePropertiesV3 = __t.object("TargetablePropertiesV3", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  get canonicalAddress() {
    return CanonicalAddress;
  },
  googlePlaceId: __t.string(),
  googlePlacePhotoName: __t.option(__t.string()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
});
export type TargetablePropertiesV3 = __Infer<typeof TargetablePropertiesV3>;

export const TargetablePropertiesV4 = __t.object("TargetablePropertiesV4", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  get canonicalAddress() {
    return CanonicalAddress;
  },
  googlePlaceId: __t.option(__t.string()),
  googlePlacePhotoName: __t.option(__t.string()),
  imageUrl: __t.option(__t.string()),
  get source() {
    return TargetablePropertySourceV1;
  },
  externalId: __t.option(__t.string()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
});
export type TargetablePropertiesV4 = __Infer<typeof TargetablePropertiesV4>;

export const TargetableProperty = __t.object("TargetableProperty", {
  id: __t.uuid(),
  get canonicalAddress() {
    return CanonicalAddress;
  },
  googlePlaceId: __t.option(__t.string()),
  googlePlacePhotoName: __t.option(__t.string()),
  imageUrl: __t.option(__t.string()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
});
export type TargetableProperty = __Infer<typeof TargetableProperty>;

// The tagged union or sum type for the algebraic type `TargetablePropertyCompsJobStatusV1`.
export const TargetablePropertyCompsJobStatusV1 = __t.enum("TargetablePropertyCompsJobStatusV1", {
  Pending: __t.unit(),
  Complete: __t.unit(),
  NoResults: __t.unit(),
  Failed: __t.unit(),
  TimedOut: __t.unit(),
});
export type TargetablePropertyCompsJobStatusV1 = __Infer<typeof TargetablePropertyCompsJobStatusV1>;

export const TargetablePropertyForUserRow = __t.object("TargetablePropertyForUserRow", {
  id: __t.uuid(),
  brand: __t.uuid(),
  googlePlaceId: __t.option(__t.string()),
  googlePlacePhotoName: __t.option(__t.string()),
  imageUrl: __t.option(__t.string()),
  externalId: __t.option(__t.string()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
  get canonicalAddress() {
    return CanonicalAddress;
  },
});
export type TargetablePropertyForUserRow = __Infer<typeof TargetablePropertyForUserRow>;

// The tagged union or sum type for the algebraic type `TargetablePropertySourceV1`.
export const TargetablePropertySourceV1 = __t.enum("TargetablePropertySourceV1", {
  Google: __t.unit(),
  Catskills: __t.unit(),
  Manual: __t.unit(),
});
export type TargetablePropertySourceV1 = __Infer<typeof TargetablePropertySourceV1>;

export const TargetedPropertyLandlordNegotiationForm = __t.object("TargetedPropertyLandlordNegotiationForm", {
  get saleType() {
    return __t.option(LandlordSaleTypeV1);
  },
  minPurchasePrice: __t.option(__t.f64()),
  fairPurchasePrice: __t.option(__t.f64()),
  usdCashOut: __t.option(__t.f64()),
  usdMonthlyDividend: __t.option(__t.f64()),
  percentAnnualRentalYield: __t.option(__t.f64()),
  submittedAt: __t.option(__t.timestamp()),
});
export type TargetedPropertyLandlordNegotiationForm = __Infer<typeof TargetedPropertyLandlordNegotiationForm>;

export const TargetedPropertySuperView = __t.object("TargetedPropertySuperView", {
  get targetableProperty() {
    return TargetableProperty;
  },
  get topThreeComps() {
    return __t.array(ComparableProperty);
  },
  userMaxPrice: __t.option(__t.f64()),
  get userIntendedContribution() {
    return __t.option(UserIntendedContribution);
  },
  get userOpennessToLandlordParticipation() {
    return __t.option(UserOpennessToLandlordParticipation);
  },
  get userPerceivedWillingnessToSell() {
    return __t.option(UserPerceivedWillingnessToSell);
  },
  get userTransactionTimeline() {
    return __t.option(UserTransactionTimeline);
  },
  get landlordNegotiationForm() {
    return __t.option(TargetedPropertyLandlordNegotiationForm);
  },
});
export type TargetedPropertySuperView = __Infer<typeof TargetedPropertySuperView>;

export const TaxReturnConnection = __t.object("TaxReturnConnection", {
  id: __t.string(),
  taxYear: __t.i16(),
  originalFileName: __t.string(),
});
export type TaxReturnConnection = __Infer<typeof TaxReturnConnection>;

export const TaxReturnDataSync = __t.object("TaxReturnDataSync", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  taxReturnV1: __t.u64(),
  underwritableEntityV1: __t.u64(),
});
export type TaxReturnDataSync = __Infer<typeof TaxReturnDataSync>;

export const TaxReturnForUserRow = __t.object("TaxReturnForUserRow", {
  id: __t.uuid(),
  originalFileName: __t.string(),
  taxYear: __t.i16(),
  createdAt: __t.timestamp(),
});
export type TaxReturnForUserRow = __Infer<typeof TaxReturnForUserRow>;

export const TaxReturnScheduledItemsV2 = __t.object("TaxReturnScheduledItemsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  taxReturn: __t.uuid(),
  underwritableEntity: __t.uuid(),
});
export type TaxReturnScheduledItemsV2 = __Infer<typeof TaxReturnScheduledItemsV2>;

export const TaxReturnUploadUrl = __t.object("TaxReturnUploadUrl", {
  uploadUrl: __t.string(),
  objectPath: __t.string(),
  contentType: __t.string(),
  contentLengthRange: __t.string(),
});
export type TaxReturnUploadUrl = __Infer<typeof TaxReturnUploadUrl>;

export const TaxReturnsToUnderwritableEntitiesV1 = __t.object("TaxReturnsToUnderwritableEntitiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  taxReturnV1: __t.u64(),
  underwritableEntityV1: __t.u64(),
});
export type TaxReturnsToUnderwritableEntitiesV1 = __Infer<typeof TaxReturnsToUnderwritableEntitiesV1>;

export const TaxReturnsToUnderwritableEntitiesV2 = __t.object("TaxReturnsToUnderwritableEntitiesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  taxReturn: __t.uuid(),
  underwritableEntity: __t.uuid(),
});
export type TaxReturnsToUnderwritableEntitiesV2 = __Infer<typeof TaxReturnsToUnderwritableEntitiesV2>;

export const TaxReturnsV1 = __t.object("TaxReturnsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  taxYear: __t.i16(),
  originalFileName: __t.string(),
  gcsUri: __t.string(),
  get jobStatus() {
    return AthenaAsyncStatusFieldsJobStatus;
  },
  error: __t.option(__t.string()),
});
export type TaxReturnsV1 = __Infer<typeof TaxReturnsV1>;

export const TaxReturnsV2 = __t.object("TaxReturnsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  taxYear: __t.i16(),
  originalFileName: __t.string(),
  gcsUri: __t.string(),
  get jobStatus() {
    return AthenaAsyncStatusFieldsJobStatus;
  },
  error: __t.option(__t.string()),
});
export type TaxReturnsV2 = __Infer<typeof TaxReturnsV2>;

export const TransactAccountsV1 = __t.object("TransactAccountsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  accountId: __t.string(),
  lastSyncedAt: __t.timestamp(),
  accountName: __t.string(),
  type: __t.string(),
  entityType: __t.option(__t.string()),
  residentType: __t.string(),
  socialSecurityNumber: __t.option(__t.string()),
  address1: __t.string(),
  address2: __t.option(__t.string()),
  city: __t.string(),
  state: __t.string(),
  zip: __t.string(),
  country: __t.string(),
  phone: __t.option(__t.string()),
  taxId: __t.option(__t.string()),
  kycStatus: __t.string(),
  kycDate: __t.option(__t.string()),
  amlStatus: __t.string(),
  amlDate: __t.option(__t.string()),
  suitabilityScore: __t.option(__t.string()),
  suitabilityDate: __t.option(__t.string()),
  suitabilityApprover: __t.option(__t.string()),
  accreditedStatus: __t.string(),
  accreditedInvestor: __t.option(__t.string()),
  accreditedInvestorDate: __t.option(__t.string()),
  transact506CLimit: __t.option(__t.string()),
  accountTotalLimit: __t.option(__t.string()),
  singleInvestmentLimit: __t.option(__t.string()),
  associatedAc: __t.option(__t.string()),
  syndicate: __t.option(__t.string()),
  tags: __t.option(__t.string()),
  notes: __t.option(__t.string()),
  approvalStatus: __t.option(__t.string()),
  approvalPrincipal: __t.option(__t.string()),
  approvalLastReview: __t.option(__t.string()),
  field1: __t.option(__t.string()),
  field2: __t.option(__t.string()),
  field3: __t.option(__t.string()),
  createdDate: __t.option(__t.string()),
  updatedDate: __t.option(__t.string()),
  accountstatus: __t.option(__t.string()),
  archiveStatus: __t.option(__t.string()),
  providerid: __t.option(__t.string()),
  email: __t.option(__t.string()),
  createdIpAddress: __t.option(__t.string()),
  updatedIpAddress: __t.option(__t.string()),
  virtualStatus: __t.option(__t.string()),
});
export type TransactAccountsV1 = __Infer<typeof TransactAccountsV1>;

export const TransactEntitiesV1 = __t.object("TransactEntitiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  partyId: __t.string(),
  lastSyncedAt: __t.timestamp(),
  domicile: __t.option(__t.string()),
  entityName: __t.string(),
  entityType: __t.option(__t.string()),
  entityDesc: __t.option(__t.string()),
  ein: __t.option(__t.string()),
  primCountry: __t.string(),
  primAddress1: __t.string(),
  primAddress2: __t.option(__t.string()),
  primCity: __t.string(),
  primState: __t.string(),
  primZip: __t.string(),
  emailAddress: __t.string(),
  emailAddress2: __t.option(__t.string()),
  phone: __t.option(__t.string()),
  phone2: __t.option(__t.string()),
  totalAssets: __t.option(__t.f64()),
  ownersAi: __t.option(__t.string()),
  kyCstatus: __t.option(__t.string()),
  amLstatus: __t.option(__t.string()),
  amLdate: __t.option(__t.string()),
  tags: __t.option(__t.string()),
  createdIpAddress: __t.option(__t.string()),
  notes: __t.option(__t.string()),
  formationDate: __t.option(__t.string()),
  createdDate: __t.option(__t.string()),
  updatedDate: __t.option(__t.string()),
  esignStatus: __t.option(__t.string()),
  partystatus: __t.option(__t.string()),
});
export type TransactEntitiesV1 = __Infer<typeof TransactEntitiesV1>;

export const TransactExternalAccountsV1 = __t.object("TransactExternalAccountsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  accountId: __t.string(),
  lastSyncedAt: __t.timestamp(),
  extAccountfullname: __t.option(__t.string()),
  extnickname: __t.option(__t.string()),
  extRoutingnumber: __t.string(),
  extAccountnumber: __t.string(),
  types: __t.string(),
  accountType: __t.string(),
  extBankname: __t.option(__t.string()),
  createdDate: __t.option(__t.string()),
  updatedDate: __t.option(__t.string()),
});
export type TransactExternalAccountsV1 = __Infer<typeof TransactExternalAccountsV1>;

export const TransactFundMovesV1 = __t.object("TransactFundMovesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  refNum: __t.string(),
  lastSyncedAt: __t.timestamp(),
  accountId: __t.string(),
  tradeId: __t.string(),
  offeringId: __t.string(),
  totalAmount: __t.string(),
  fundStatus: __t.string(),
  bankname: __t.option(__t.string()),
  accountnumber: __t.option(__t.string()),
  routingnumber: __t.option(__t.string()),
  accountfullname: __t.option(__t.string()),
  transactionstatus: __t.option(__t.string()),
  routingNumberStatus: __t.option(__t.string()),
  errors: __t.option(__t.string()),
  createdDate: __t.option(__t.string()),
  accountName: __t.option(__t.string()),
  clientName: __t.option(__t.string()),
  issueName: __t.option(__t.string()),
  ccreferencenumber: __t.option(__t.string()),
  vantivTransactionId: __t.option(__t.string()),
  vantivTransactionMessage: __t.option(__t.string()),
  vantivTokenMessage: __t.option(__t.string()),
});
export type TransactFundMovesV1 = __Infer<typeof TransactFundMovesV1>;

export const TransactLinksV1 = __t.object("TransactLinksV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  lastSyncedAt: __t.timestamp(),
  firstEntryType: __t.string(),
  firstEntry: __t.string(),
  relatedEntry: __t.string(),
  relatedEntryType: __t.string(),
  linkType: __t.option(__t.string()),
  notes: __t.option(__t.string()),
});
export type TransactLinksV1 = __Infer<typeof TransactLinksV1>;

export const TransactOfferingsV1 = __t.object("TransactOfferingsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  offeringId: __t.string(),
  lastSyncedAt: __t.timestamp(),
  issuerId: __t.string(),
  issueName: __t.string(),
  issueType: __t.string(),
  targetAmount: __t.string(),
  minAmount: __t.string(),
  maxAmount: __t.string(),
  unitPrice: __t.string(),
  totalShares: __t.option(__t.string()),
  remainingShares: __t.option(__t.string()),
  startDate: __t.string(),
  endDate: __t.string(),
  offeringStatus: __t.string(),
  offeringText: __t.string(),
  stampingText: __t.string(),
  escrowAccountNumber: __t.option(__t.string()),
  field1: __t.option(__t.string()),
  field2: __t.option(__t.string()),
  field3: __t.option(__t.string()),
  createdDate: __t.option(__t.string()),
  acceptingInvestments: __t.option(__t.string()),
  committedAmount: __t.option(__t.string()),
  fundedAmount: __t.option(__t.string()),
  pendingAmount: __t.option(__t.string()),
  providerId: __t.option(__t.string()),
  updatedIpAddress: __t.option(__t.string()),
  createdIpAddress: __t.option(__t.string()),
});
export type TransactOfferingsV1 = __Infer<typeof TransactOfferingsV1>;

export const TransactPartiesV1 = __t.object("TransactPartiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  partyId: __t.string(),
  lastSyncedAt: __t.timestamp(),
  firstName: __t.string(),
  middleInitial: __t.option(__t.string()),
  lastName: __t.string(),
  domicile: __t.string(),
  socialSecurityNumber: __t.option(__t.string()),
  dob: __t.string(),
  primAddress1: __t.string(),
  primAddress2: __t.option(__t.string()),
  primCity: __t.string(),
  primState: __t.string(),
  primZip: __t.string(),
  primCountry: __t.string(),
  emailAddress: __t.string(),
  emailAddress2: __t.option(__t.string()),
  phone: __t.option(__t.string()),
  phone2: __t.option(__t.string()),
  occupation: __t.option(__t.string()),
  associatedPerson: __t.option(__t.string()),
  empStatus: __t.option(__t.string()),
  empName: __t.option(__t.string()),
  empCountry: __t.option(__t.string()),
  empAddress1: __t.option(__t.string()),
  empAddress2: __t.option(__t.string()),
  empCity: __t.option(__t.string()),
  empState: __t.option(__t.string()),
  empZip: __t.option(__t.string()),
  investTo: __t.option(__t.string()),
  currentAnnIncome: __t.option(__t.string()),
  avgAnnIncome: __t.option(__t.string()),
  currentHouseholdIncome: __t.option(__t.string()),
  avgHouseholdIncome: __t.option(__t.string()),
  householdNetworth: __t.option(__t.string()),
  kycStatus: __t.option(__t.string()),
  amlStatus: __t.option(__t.string()),
  amlDate: __t.option(__t.string()),
  tags: __t.option(__t.string()),
  notes: __t.option(__t.string()),
  esignStatus: __t.option(__t.string()),
  documentKey: __t.option(__t.string()),
  field1: __t.option(__t.string()),
  field2: __t.option(__t.string()),
  field3: __t.option(__t.string()),
  createdDate: __t.option(__t.string()),
  updatedDate: __t.option(__t.string()),
  partystatus: __t.option(__t.string()),
  createdIpAddress: __t.option(__t.string()),
  status: __t.option(__t.string()),
});
export type TransactPartiesV1 = __Infer<typeof TransactPartiesV1>;

export const TransactRateLimitV1 = __t.object("TransactRateLimitV1", {
  key: __t.string(),
  tokens: __t.i32(),
  maxTokens: __t.i32(),
  lastRefillAt: __t.timestamp(),
  refillRatePerMinute: __t.i32(),
});
export type TransactRateLimitV1 = __Infer<typeof TransactRateLimitV1>;

export const TransactSyncCronV1 = __t.object("TransactSyncCronV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type TransactSyncCronV1 = __Infer<typeof TransactSyncCronV1>;

export const TransactSyncJobsV1 = __t.object("TransactSyncJobsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  entity: __t.string(),
  status: __t.string(),
  currentOffset: __t.i32(),
  pagesProcessed: __t.i32(),
  totalRecords: __t.option(__t.i32()),
  lastPageAt: __t.option(__t.timestamp()),
  error: __t.option(__t.string()),
});
export type TransactSyncJobsV1 = __Infer<typeof TransactSyncJobsV1>;

export const TransactSyncPageScheduleV1 = __t.object("TransactSyncPageScheduleV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  job: __t.u64(),
});
export type TransactSyncPageScheduleV1 = __Infer<typeof TransactSyncPageScheduleV1>;

export const TransactTradesV1 = __t.object("TransactTradesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  tradeId: __t.string(),
  lastSyncedAt: __t.timestamp(),
  transactionType: __t.string(),
  transactionAmount: __t.option(__t.string()),
  transactionDate: __t.option(__t.string()),
  transactionStatus: __t.option(__t.string()),
  rrName: __t.option(__t.string()),
  rrApprovalStatus: __t.option(__t.string()),
  rrApprovalDate: __t.option(__t.string()),
  principalName: __t.option(__t.string()),
  principalDate: __t.option(__t.string()),
  principalApprovalStatus: __t.option(__t.string()),
  closeId: __t.option(__t.string()),
  eligibleToClose: __t.option(__t.string()),
  notes: __t.option(__t.string()),
  shares: __t.option(__t.string()),
  sharePrice: __t.option(__t.f64()),
  totalShares: __t.option(__t.string()),
  remainingShares: __t.option(__t.string()),
  unitPrice: __t.option(__t.string()),
  updatedDate: __t.option(__t.string()),
  totalAmount: __t.string(),
  signoption: __t.option(__t.string()),
  paymentStatus: __t.option(__t.string()),
  partyId: __t.option(__t.string()),
  partyType: __t.option(__t.string()),
  tradeStatus: __t.option(__t.string()),
  offeringId: __t.string(),
  field3: __t.option(__t.string()),
  field2: __t.option(__t.string()),
  field1: __t.option(__t.string()),
  esignStatus: __t.option(__t.string()),
  escrowId: __t.option(__t.string()),
  errors: __t.option(__t.string()),
  documentKey: __t.option(__t.string()),
  createdDate: __t.option(__t.string()),
  archived: __t.option(__t.string()),
  accountId: __t.string(),
  archiveStatus: __t.option(__t.string()),
  orderStatus: __t.option(__t.string()),
  archivedStatus: __t.option(__t.string()),
  id: __t.option(__t.string()),
});
export type TransactTradesV1 = __Infer<typeof TransactTradesV1>;

export const TransactWebhookSyncScheduleV1 = __t.object("TransactWebhookSyncScheduleV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  entity: __t.string(),
  entityId: __t.string(),
});
export type TransactWebhookSyncScheduleV1 = __Infer<typeof TransactWebhookSyncScheduleV1>;

export const TriggerUnderwritingOnboardingScheduleItemsV1 = __t.object("TriggerUnderwritingOnboardingScheduleItemsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  brandV1: __t.u64(),
  attempts: __t.u8(),
});
export type TriggerUnderwritingOnboardingScheduleItemsV1 = __Infer<typeof TriggerUnderwritingOnboardingScheduleItemsV1>;

export const TriggerUnderwritingOnboardingScheduleItemsV2 = __t.object("TriggerUnderwritingOnboardingScheduleItemsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  brand: __t.uuid(),
  attempts: __t.u8(),
});
export type TriggerUnderwritingOnboardingScheduleItemsV2 = __Infer<typeof TriggerUnderwritingOnboardingScheduleItemsV2>;

export const TtwBackerRowV1 = __t.object("TtwBackerRowV1", {
  displayName: __t.string(),
  shares: __t.i64(),
  pledgedAt: __t.timestamp(),
  avatarCdnPath: __t.option(__t.string()),
  isNominator: __t.bool(),
});
export type TtwBackerRowV1 = __Infer<typeof TtwBackerRowV1>;

export const TtwBackersRowV1 = __t.object("TtwBackersRowV1", {
  get backers() {
    return __t.array(TtwBackerRowV1);
  },
  backerCount: __t.u32(),
  nominatorDisplayName: __t.option(__t.string()),
  totalReservedDollars: __t.option(__t.i64()),
});
export type TtwBackersRowV1 = __Infer<typeof TtwBackersRowV1>;

export const TtwHighlightV1 = __t.object("TtwHighlightV1", {
  text: __t.string(),
  icon: __t.string(),
});
export type TtwHighlightV1 = __Infer<typeof TtwHighlightV1>;

export const TtwKeyStatV1 = __t.object("TtwKeyStatV1", {
  label: __t.string(),
  icon: __t.string(),
  value: __t.string(),
});
export type TtwKeyStatV1 = __Infer<typeof TtwKeyStatV1>;

export const TtwPageGalleryV1 = __t.object("TtwPageGalleryV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  ttwPage: __t.uuid(),
  sortOrder: __t.i32(),
  objectPath: __t.string(),
});
export type TtwPageGalleryV1 = __Infer<typeof TtwPageGalleryV1>;

export const TtwPageHighlightsV1 = __t.object("TtwPageHighlightsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  ttwPage: __t.uuid(),
  sortOrder: __t.i32(),
  text: __t.string(),
  icon: __t.string(),
});
export type TtwPageHighlightsV1 = __Infer<typeof TtwPageHighlightsV1>;

export const TtwPageKeyStatsV1 = __t.object("TtwPageKeyStatsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  ttwPage: __t.uuid(),
  sortOrder: __t.i32(),
  label: __t.string(),
  icon: __t.string(),
  value: __t.string(),
});
export type TtwPageKeyStatsV1 = __Infer<typeof TtwPageKeyStatsV1>;

export const TtwPageRowV2 = __t.object("TtwPageRowV2", {
  hasPage: __t.bool(),
  ownerBrand: __t.option(__t.uuid()),
  suggestedBusinessName: __t.option(__t.string()),
  suggestedCategory: __t.option(__t.string()),
  suggestedTargetProperty: __t.option(__t.uuid()),
  eligibleTargetProperties: __t.array(__t.uuid()),
  cardId: __t.option(__t.uuid()),
  featureImage: __t.string(),
  get pitchVideoKind() {
    return TtwPitchVideoKindV1;
  },
  pitchVideoValue: __t.option(__t.string()),
  get pitchVideoProvider() {
    return __t.option(TtwVideoProviderV1);
  },
  businessName: __t.string(),
  category: __t.string(),
  targetProperty: __t.option(__t.uuid()),
  get targetPropertyAddress() {
    return __t.option(CanonicalAddress);
  },
  targetPropertyLatitude: __t.option(__t.f64()),
  targetPropertyLongitude: __t.option(__t.f64()),
  targetPropertySqft: __t.option(__t.f64()),
  suggestedPropertySqft: __t.option(__t.f64()),
  showNominator: __t.bool(),
  showTotalReserved: __t.bool(),
  showAppreciationShare: __t.bool(),
  get highlights() {
    return __t.array(TtwHighlightV1);
  },
  stewardImage: __t.option(__t.string()),
  stewardQuote: __t.option(__t.string()),
  stewardAttribution: __t.option(__t.string()),
  stewardAbout: __t.option(__t.string()),
  get keyStats() {
    return __t.array(TtwKeyStatV1);
  },
  realEstateAbout: __t.option(__t.string()),
  targetArea: __t.option(__t.string()),
  gallery: __t.array(__t.string()),
  propertyType: __t.option(__t.string()),
  stories: __t.option(__t.string()),
  yearBuilt: __t.option(__t.string()),
  propertySqft: __t.option(__t.i32()),
  showEstimatedValueChart: __t.bool(),
  sharePriceCents: __t.i64(),
  totalShares: __t.i64(),
  targetReturnBps: __t.i32(),
  targetReturnBpsMax: __t.i32(),
  targetRaiseCents: __t.i64(),
  get stage() {
    return TtwPageStageV1;
  },
  appreciationShareBps: __t.i32(),
});
export type TtwPageRowV2 = __Infer<typeof TtwPageRowV2>;

// The tagged union or sum type for the algebraic type `TtwPageStageV1`.
export const TtwPageStageV1 = __t.enum("TtwPageStageV1", {
  Nominated: __t.unit(),
  Planning: __t.unit(),
  Fundraising: __t.unit(),
});
export type TtwPageStageV1 = __Infer<typeof TtwPageStageV1>;

export const TtwPagesV2 = __t.object("TtwPagesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  shareableBusinessCard: __t.uuid(),
  featureImage: __t.string(),
  get pitchVideoKind() {
    return TtwPitchVideoKindV1;
  },
  pitchVideoValue: __t.option(__t.string()),
  get pitchVideoProvider() {
    return __t.option(TtwVideoProviderV1);
  },
  businessName: __t.string(),
  category: __t.string(),
  targetProperty: __t.option(__t.uuid()),
  showNominator: __t.bool(),
  stewardImage: __t.option(__t.string()),
  stewardQuote: __t.option(__t.string()),
  stewardAttribution: __t.option(__t.string()),
  stewardAbout: __t.option(__t.string()),
  realEstateAbout: __t.option(__t.string()),
  targetArea: __t.option(__t.string()),
  sharePriceCents: __t.i64(),
  totalShares: __t.i64(),
  targetReturnBps: __t.i32(),
  targetReturnBpsMax: __t.i32(),
  targetRaiseCents: __t.i64(),
  get stage() {
    return TtwPageStageV1;
  },
  propertyType: __t.option(__t.string()),
  stories: __t.option(__t.string()),
  yearBuilt: __t.option(__t.string()),
  propertySqft: __t.option(__t.i32()),
  showTotalReserved: __t.bool(),
  appreciationShareBps: __t.i32(),
  showAppreciationShare: __t.bool(),
  showEstimatedValueChart: __t.bool(),
});
export type TtwPagesV2 = __Infer<typeof TtwPagesV2>;

// The tagged union or sum type for the algebraic type `TtwPitchVideoKindV1`.
export const TtwPitchVideoKindV1 = __t.enum("TtwPitchVideoKindV1", {
  None: __t.unit(),
  Upload: __t.unit(),
  External: __t.unit(),
});
export type TtwPitchVideoKindV1 = __Infer<typeof TtwPitchVideoKindV1>;

// The tagged union or sum type for the algebraic type `TtwVideoProviderV1`.
export const TtwVideoProviderV1 = __t.enum("TtwVideoProviderV1", {
  Youtube: __t.unit(),
  Vimeo: __t.unit(),
});
export type TtwVideoProviderV1 = __Infer<typeof TtwVideoProviderV1>;

export const UnderwritableEntitiesAndTargetablePropertiesToComparablePropertiesV1 = __t.object("UnderwritableEntitiesAndTargetablePropertiesToComparablePropertiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  underwritableEntityV1: __t.u64(),
  targetablePropertyV1: __t.u64(),
  comparablePropertyV1: __t.u64(),
  approved: __t.bool(),
});
export type UnderwritableEntitiesAndTargetablePropertiesToComparablePropertiesV1 = __Infer<typeof UnderwritableEntitiesAndTargetablePropertiesToComparablePropertiesV1>;

export const UnderwritableEntitiesAndTargetablePropertiesToComparablePropertiesV2 = __t.object("UnderwritableEntitiesAndTargetablePropertiesToComparablePropertiesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  underwritableEntity: __t.uuid(),
  targetableProperty: __t.uuid(),
  comparableProperty: __t.uuid(),
  approved: __t.bool(),
});
export type UnderwritableEntitiesAndTargetablePropertiesToComparablePropertiesV2 = __Infer<typeof UnderwritableEntitiesAndTargetablePropertiesToComparablePropertiesV2>;

export const UnderwritableEntitiesV1 = __t.object("UnderwritableEntitiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  brandV1: __t.u64(),
  friendlyName: __t.string(),
  purchasingPower: __t.option(__t.f64()),
});
export type UnderwritableEntitiesV1 = __Infer<typeof UnderwritableEntitiesV1>;

export const UnderwritableEntitiesV2 = __t.object("UnderwritableEntitiesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  brandV1: __t.u64(),
  friendlyName: __t.string(),
  purchasingPower: __t.option(__t.f64()),
  get urJobStatus() {
    return __t.option(UrJobStatusV1);
  },
  urJobAttempts: __t.option(__t.u32()),
  urJobLastPolledAt: __t.option(__t.timestamp()),
  urJobCompletedAt: __t.option(__t.timestamp()),
  urJobErrorKind: __t.option(__t.string()),
  urJobErrorMessage: __t.option(__t.string()),
});
export type UnderwritableEntitiesV2 = __Infer<typeof UnderwritableEntitiesV2>;

export const UnderwritableEntitiesV3 = __t.object("UnderwritableEntitiesV3", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.u64(),
  brandV1: __t.u64(),
  friendlyName: __t.string(),
  purchasingPower: __t.option(__t.f64()),
  get urJobStatus() {
    return __t.option(UrJobStatusV1);
  },
  urJobAttempts: __t.option(__t.u32()),
  urJobLastPolledAt: __t.option(__t.timestamp()),
  urJobCompletedAt: __t.option(__t.timestamp()),
  urJobErrorKind: __t.option(__t.string()),
  urJobErrorMessage: __t.option(__t.string()),
  initialQuestionsComplete: __t.bool(),
});
export type UnderwritableEntitiesV3 = __Infer<typeof UnderwritableEntitiesV3>;

export const UnderwritableEntitiesV4 = __t.object("UnderwritableEntitiesV4", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.uuid(),
  brand: __t.uuid(),
  friendlyName: __t.string(),
  purchasingPower: __t.option(__t.f64()),
  get urJobStatus() {
    return __t.option(UrJobStatusV1);
  },
  urJobAttempts: __t.option(__t.u32()),
  urJobLastPolledAt: __t.option(__t.timestamp()),
  urJobCompletedAt: __t.option(__t.timestamp()),
  urJobErrorKind: __t.option(__t.string()),
  urJobErrorMessage: __t.option(__t.string()),
  initialQuestionsComplete: __t.bool(),
});
export type UnderwritableEntitiesV4 = __Infer<typeof UnderwritableEntitiesV4>;

export const UnderwritingQuestionsV1 = __t.object("UnderwritingQuestionsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  underwritableEntityV1: __t.u64(),
  get question() {
    return QuestionWithAnswer;
  },
});
export type UnderwritingQuestionsV1 = __Infer<typeof UnderwritingQuestionsV1>;

export const UnderwritingQuestionsV2 = __t.object("UnderwritingQuestionsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  underwritableEntity: __t.uuid(),
  get question() {
    return QuestionWithAnswer;
  },
});
export type UnderwritingQuestionsV2 = __Infer<typeof UnderwritingQuestionsV2>;

export const UnderwritingResult = __t.object("UnderwritingResult", {
  runId: __t.u64(),
  runDate: __t.option(__t.string()),
  maxAffordability: __t.option(__t.f64()),
  get questions() {
    return __t.array(QuestionWithAnswer);
  },
  get underwritingResultsJobStatus() {
    return __t.option(UrJobStatusV1);
  },
  underwritingResultsJobErrorKind: __t.option(__t.string()),
  initialQuestionsComplete: __t.bool(),
});
export type UnderwritingResult = __Infer<typeof UnderwritingResult>;

export const UnderwritingResultsJobScheduledItemsV1 = __t.object("UnderwritingResultsJobScheduledItemsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  underwritableEntityV1: __t.u64(),
});
export type UnderwritingResultsJobScheduledItemsV1 = __Infer<typeof UnderwritingResultsJobScheduledItemsV1>;

export const UnderwritingResultsJobScheduledItemsV2 = __t.object("UnderwritingResultsJobScheduledItemsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  underwritableEntity: __t.uuid(),
});
export type UnderwritingResultsJobScheduledItemsV2 = __Infer<typeof UnderwritingResultsJobScheduledItemsV2>;

export const UnderwritingResultsScheduledItemsV1 = __t.object("UnderwritingResultsScheduledItemsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  underwritableEntityV1: __t.u64(),
});
export type UnderwritingResultsScheduledItemsV1 = __Infer<typeof UnderwritingResultsScheduledItemsV1>;

export const UnderwritingResultsScheduledItemsV2 = __t.object("UnderwritingResultsScheduledItemsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  underwritableEntity: __t.uuid(),
});
export type UnderwritingResultsScheduledItemsV2 = __Infer<typeof UnderwritingResultsScheduledItemsV2>;

export const UnderwritingResultsWebhookScheduleV1 = __t.object("UnderwritingResultsWebhookScheduleV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  brand: __t.uuid(),
  underwritableEntity: __t.uuid(),
});
export type UnderwritingResultsWebhookScheduleV1 = __Infer<typeof UnderwritingResultsWebhookScheduleV1>;

export const UpdateInvitedOnboardingStepResult = __t.object("UpdateInvitedOnboardingStepResult", {
  get invitedStep() {
    return InvitedOnboardingStep;
  },
});
export type UpdateInvitedOnboardingStepResult = __Infer<typeof UpdateInvitedOnboardingStepResult>;

export const UpsertUserInfoResult = __t.object("UpsertUserInfoResult", {
  clerkUserId: __t.string(),
});
export type UpsertUserInfoResult = __Infer<typeof UpsertUserInfoResult>;

// The tagged union or sum type for the algebraic type `UrJobStatusV1`.
export const UrJobStatusV1 = __t.enum("UrJobStatusV1", {
  Pending: __t.unit(),
  Complete: __t.unit(),
  Failed: __t.unit(),
  TimedOut: __t.unit(),
});
export type UrJobStatusV1 = __Infer<typeof UrJobStatusV1>;

export const UserConnectionsV1 = __t.object("UserConnectionsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  connectionId: __t.connectionId(),
  identity: __t.identity(),
  clerkUserIdV1: __t.string(),
  connectedAt: __t.timestamp(),
});
export type UserConnectionsV1 = __Infer<typeof UserConnectionsV1>;

export const UserIdentitiesV1 = __t.object("UserIdentitiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  identity: __t.identity(),
  clerkUserIdV1: __t.string(),
  firstSeenAt: __t.timestamp(),
  lastSeenAt: __t.timestamp(),
});
export type UserIdentitiesV1 = __Infer<typeof UserIdentitiesV1>;

export const UserInfoV1 = __t.object("UserInfoV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  clerkUserIdV1: __t.string(),
  firstName: __t.string(),
  lastName: __t.string(),
  phone: __t.string(),
  dob: __t.string(),
  citizenship: __t.string(),
  residency: __t.string(),
  get address() {
    return CanonicalAddress;
  },
});
export type UserInfoV1 = __Infer<typeof UserInfoV1>;

export const UserInfoV2 = __t.object("UserInfoV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  clerkUserId: __t.string(),
  firstName: __t.option(__t.string()),
  lastName: __t.option(__t.string()),
  phone: __t.option(__t.string()),
  dob: __t.option(__t.string()),
  citizenship: __t.option(__t.string()),
  residency: __t.option(__t.string()),
  get address() {
    return __t.option(CanonicalAddress);
  },
  avatarCdnPath: __t.option(__t.string()),
  isAccreditedInvestor: __t.option(__t.bool()),
  accreditationAttestedAt: __t.option(__t.timestamp()),
});
export type UserInfoV2 = __Infer<typeof UserInfoV2>;

export const UserIntendedContribution = __t.object("UserIntendedContribution", {
  value: __t.f64(),
  note: __t.option(__t.string()),
});
export type UserIntendedContribution = __Infer<typeof UserIntendedContribution>;

export const UserMaxPrice = __t.object("UserMaxPrice", {
  value: __t.f64(),
  note: __t.option(__t.string()),
});
export type UserMaxPrice = __Infer<typeof UserMaxPrice>;

export const UserOpennessToLandlordParticipation = __t.object("UserOpennessToLandlordParticipation", {
  value: __t.i8(),
  note: __t.option(__t.string()),
});
export type UserOpennessToLandlordParticipation = __Infer<typeof UserOpennessToLandlordParticipation>;

export const UserPerceivedWillingnessToSell = __t.object("UserPerceivedWillingnessToSell", {
  value: __t.i8(),
  note: __t.option(__t.string()),
});
export type UserPerceivedWillingnessToSell = __Infer<typeof UserPerceivedWillingnessToSell>;

// The tagged union or sum type for the algebraic type `UserPriceJudgement`.
export const UserPriceJudgement = __t.enum("UserPriceJudgement", {
  High: __t.unit(),
  Low: __t.unit(),
  Correct: __t.unit(),
});
export type UserPriceJudgement = __Infer<typeof UserPriceJudgement>;

export const UserTransactionTimeline = __t.object("UserTransactionTimeline", {
  get value() {
    return UserTransactionTimelineOptions;
  },
  note: __t.option(__t.string()),
});
export type UserTransactionTimeline = __Infer<typeof UserTransactionTimeline>;

// The tagged union or sum type for the algebraic type `UserTransactionTimelineOptions`.
export const UserTransactionTimelineOptions = __t.enum("UserTransactionTimelineOptions", {
  Immediately: __t.unit(),
  Within30Days: __t.unit(),
  Within60Days: __t.unit(),
  Within90Days: __t.unit(),
  Other: __t.unit(),
});
export type UserTransactionTimelineOptions = __Infer<typeof UserTransactionTimelineOptions>;

export const UserUwAcknowledgmentsV1 = __t.object("UserUwAcknowledgmentsV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  clerkUserIdV1: __t.string(),
  underwritableEntityIdV1: __t.u64(),
  messageKey: __t.string(),
  compositeId: __t.string(),
});
export type UserUwAcknowledgmentsV1 = __Infer<typeof UserUwAcknowledgmentsV1>;

export const UserUwAcknowledgmentsV2 = __t.object("UserUwAcknowledgmentsV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  clerkUserId: __t.string(),
  underwritableEntityId: __t.uuid(),
  messageKey: __t.string(),
  compositeId: __t.string(),
});
export type UserUwAcknowledgmentsV2 = __Infer<typeof UserUwAcknowledgmentsV2>;

export const UsersV1 = __t.object("UsersV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  clerkUserId: __t.string(),
  email: __t.string(),
  firstSeenAt: __t.timestamp(),
  lastSeenAt: __t.timestamp(),
});
export type UsersV1 = __Infer<typeof UsersV1>;

export const UwEntitiesToTargetablePropertiesV1 = __t.object("UwEntitiesToTargetablePropertiesV1", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  underwritableEntityV1: __t.u64(),
  targetablePropertyV1: __t.u64(),
  topThreeComps: __t.array(__t.u64()),
  priceEstimate: __t.option(__t.f64()),
  get userThinksPriceEstimateIs() {
    return __t.option(UserPriceJudgement);
  },
  get userMaxPrice() {
    return __t.option(UserMaxPrice);
  },
});
export type UwEntitiesToTargetablePropertiesV1 = __Infer<typeof UwEntitiesToTargetablePropertiesV1>;

export const UwEntitiesToTargetablePropertiesV2 = __t.object("UwEntitiesToTargetablePropertiesV2", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  underwritableEntityV1: __t.u64(),
  targetablePropertyV1: __t.u64(),
  topThreeComps: __t.array(__t.u64()),
  priceEstimate: __t.option(__t.f64()),
  get userThinksPriceEstimateIs() {
    return __t.option(UserPriceJudgement);
  },
  get userMaxPrice() {
    return __t.option(UserMaxPrice);
  },
  get userIntendedContribution() {
    return __t.option(UserIntendedContribution);
  },
  get userPerceivedWillingnessToSell() {
    return __t.option(UserPerceivedWillingnessToSell);
  },
  get userOpennessToLandlordParticipation() {
    return __t.option(UserOpennessToLandlordParticipation);
  },
  get userTransactionTimeline() {
    return __t.option(UserTransactionTimeline);
  },
});
export type UwEntitiesToTargetablePropertiesV2 = __Infer<typeof UwEntitiesToTargetablePropertiesV2>;

export const UwEntitiesToTargetablePropertiesV3 = __t.object("UwEntitiesToTargetablePropertiesV3", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  underwritableEntityV1: __t.u64(),
  targetablePropertyV1: __t.u64(),
  topThreeComps: __t.array(__t.u64()),
  priceEstimate: __t.option(__t.f64()),
  get userThinksPriceEstimateIs() {
    return __t.option(UserPriceJudgement);
  },
  get userMaxPrice() {
    return __t.option(UserMaxPrice);
  },
  get userIntendedContribution() {
    return __t.option(UserIntendedContribution);
  },
  get userPerceivedWillingnessToSell() {
    return __t.option(UserPerceivedWillingnessToSell);
  },
  get userOpennessToLandlordParticipation() {
    return __t.option(UserOpennessToLandlordParticipation);
  },
  get userTransactionTimeline() {
    return __t.option(UserTransactionTimeline);
  },
  compsJobBrandV1: __t.option(__t.u64()),
  get compsJobStatus() {
    return __t.option(TargetablePropertyCompsJobStatusV1);
  },
  compsJobAttempts: __t.u8(),
  compsJobLastPolledAt: __t.option(__t.timestamp()),
  compsJobCompletedAt: __t.option(__t.timestamp()),
  compsJobErrorKind: __t.option(__t.string()),
  compsJobErrorMessage: __t.option(__t.string()),
});
export type UwEntitiesToTargetablePropertiesV3 = __Infer<typeof UwEntitiesToTargetablePropertiesV3>;

export const UwEntitiesToTargetablePropertiesV4 = __t.object("UwEntitiesToTargetablePropertiesV4", {
  createdAt: __t.timestamp(),
  updatedAt: __t.option(__t.timestamp()),
  deletedAt: __t.option(__t.timestamp()),
  id: __t.string(),
  underwritableEntity: __t.uuid(),
  targetableProperty: __t.uuid(),
  topThreeComps: __t.array(__t.uuid()),
  priceEstimate: __t.option(__t.f64()),
  get userThinksPriceEstimateIs() {
    return __t.option(UserPriceJudgement);
  },
  get userMaxPrice() {
    return __t.option(UserMaxPrice);
  },
  get userIntendedContribution() {
    return __t.option(UserIntendedContribution);
  },
  get userPerceivedWillingnessToSell() {
    return __t.option(UserPerceivedWillingnessToSell);
  },
  get userOpennessToLandlordParticipation() {
    return __t.option(UserOpennessToLandlordParticipation);
  },
  get userTransactionTimeline() {
    return __t.option(UserTransactionTimeline);
  },
  compsJobBrand: __t.option(__t.uuid()),
  get compsJobStatus() {
    return __t.option(TargetablePropertyCompsJobStatusV1);
  },
  compsJobAttempts: __t.u8(),
  compsJobLastPolledAt: __t.option(__t.timestamp()),
  compsJobCompletedAt: __t.option(__t.timestamp()),
  compsJobErrorKind: __t.option(__t.string()),
  compsJobErrorMessage: __t.option(__t.string()),
});
export type UwEntitiesToTargetablePropertiesV4 = __Infer<typeof UwEntitiesToTargetablePropertiesV4>;

export const YesNoAnswer = __t.object("YesNoAnswer", {
  value: __t.bool(),
  note: __t.option(__t.string()),
});
export type YesNoAnswer = __Infer<typeof YesNoAnswer>;

export const YesnoQuestionWithAnswer = __t.object("YesnoQuestionWithAnswer", {
  id: __t.string(),
  title: __t.string(),
  subtitle: __t.option(__t.string()),
  get details() {
    return __t.option(QuestionDetails);
  },
  get answer() {
    return __t.option(YesNoAnswer);
  },
});
export type YesnoQuestionWithAnswer = __Infer<typeof YesnoQuestionWithAnswer>;

